<template>
  <div class="c1-main c1-users-page" @click="c1HamMenuOpen = false; c1ShiftMenuOpen = false; c1TopTab = null">

    <!-- TOAST -->
    <transition name="u1-toast-fade">
      <div v-if="u1Toast" class="u1-toast" :style="{ background: u1Toast.color }">{{ u1Toast.msg }}</div>
    </transition>

    <!-- TOP BAR -->
    <div class="c1-sticky-top">
    <div class="c1-tib" @click="c1SlideOpen = null; c1HamMenuOpen = false; c1ShiftMenuOpen = false">
      <!-- LEFT 25% — Viki face flush left -->
      <div class="c1-tib-side c1-tib-left" style="padding-left:0;gap:8px;">
        <div class="c1-viki-topface"
          :class="{ 'c1-viki-topface--active': c1PanelActiveContent === 'viki' }"
          @click.stop="c1SelectPanel('viki','')"
        >
          <viki-face :mood="c1VikiMood" :speaking="c1VikiSpeaking" :size="44" style="width:72px;height:44px;display:block;overflow:hidden;border-radius:0;"/>
        </div>
        <div class="c1-shift-wrap" @click.stop="c1ShiftMenuOpen = !c1ShiftMenuOpen; c1HamMenuOpen = false">
          <div class="c1-tib-shift-pill" :class="{ open: c1ShiftMenuOpen }">
            ⏱ {{ c1ShiftElapsed }}
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:10px;height:10px;margin-left:3px;transition:transform .2s" :style="{ transform: c1ShiftMenuOpen ? 'rotate(180deg)' : 'rotate(0deg)' }"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
        </div>
      </div>
      <!-- CENTER 50% — module title -->
      <div class="c1-tib-center">
        <div class="c1-tib-mod-title">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:14px;height:14px;flex-shrink:0"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
          Users
        </div>
      </div>
      <!-- RIGHT 25% — hamburger only -->
      <div class="c1-tib-side c1-tib-right">
        <div class="c1-ham-wrap" @click.stop>
          <button class="c1-ham-btn" :class="{ open: c1HamMenuOpen }" @click="c1HamMenuOpen = !c1HamMenuOpen; c1ShiftMenuOpen = false">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:18px;height:18px"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
          </button>
        </div>
      </div>
    </div>
    <!-- SHIFT DRAWER -->
    <div class="c1-top-drawer c1-shift-drawer" :class="{ open: c1ShiftMenuOpen }" @click.stop>
      <div class="c1-td-inner">
        <div class="c1-td-section-lbl">My Shift</div>
        <div class="c1-td-status-row">
          <div class="c1-td-stat">
            <div class="c1-td-stat-val c1-mono">{{ c1ShiftStartTime ? new Date(c1ShiftStartTime).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' }) : '—' }}</div>
            <div class="c1-td-stat-lbl">Started</div>
          </div>
          <div class="c1-td-stat">
            <div class="c1-td-stat-val c1-mono" style="color:var(--c1-dp)">{{ c1ShiftElapsed }}</div>
            <div class="c1-td-stat-lbl">Elapsed</div>
          </div>
          <div class="c1-td-stat">
            <div class="c1-td-stat-val">{{ c1BathroomCount }}×</div>
            <div class="c1-td-stat-lbl">🚽 Bathroom</div>
          </div>
          <div class="c1-td-stat">
            <div class="c1-td-stat-val">{{ c1CoffeeCount }}×</div>
            <div class="c1-td-stat-lbl">☕ Coffee</div>
          </div>
        </div>
        <div class="c1-td-btn-row">
          <button class="c1-td-btn c1-td-btn-shift"   :class="{ active: c1Status === 'shift' }"   @click.stop="c1SetStatus('shift')">▶ On Shift</button>
          <button class="c1-td-btn c1-td-btn-bathroom" :class="{ active: c1Status === 'bathroom' }" @click.stop="c1SetStatus('bathroom')">🚽 Bathroom</button>
          <button class="c1-td-btn c1-td-btn-coffee"  :class="{ active: c1Status === 'coffee' }"  @click.stop="c1SetStatus('coffee')">☕ Coffee</button>
          <button class="c1-td-btn c1-td-btn-break"   :class="{ active: c1Status === 'break' }"   @click.stop="c1SetStatus('break')">⏸ Break</button>
          <button class="c1-td-btn c1-td-btn-lunch"   :class="{ active: c1Status === 'lunch' }"   @click.stop="c1SetStatus('lunch')">🍽 Lunch</button>
          <button class="c1-td-btn c1-td-btn-end"     @click.stop="c1SetStatus('end')">⏹ End Shift</button>
        </div>
      </div>
    </div>
    <!-- HAM NAV DRAWER -->
    <div class="c1-top-drawer c1-ham-drawer" :class="{ open: c1HamMenuOpen }" @click.stop>
      <div class="c1-td-inner c1-td-nav-grid">
        <router-link to="/clients1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:var(--c1-dp)"></span>Clients</router-link>
        <router-link to="/tasks1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:var(--c1-sc)"></span>Tasks</router-link>
        <router-link to="/stats1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:var(--c1-ld)"></span>Statistics</router-link>
        <router-link to="/chat1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:var(--c1-rf)"></span>Chat</router-link>
        <router-link to="/communications1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#3b82f6"></span>Communications</router-link>
        <router-link to="/affiliation1" class="c1-td-nav-item" :class="{ on: $route.path === '/affiliation1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#8b5cf6"></span>Affiliation</router-link>
        <router-link to="/finance1" class="c1-td-nav-item" :class="{ on: $route.path === '/finance1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#10b981"></span>Finance</router-link>
        <router-link to="/shifts1" class="c1-td-nav-item" :class="{ on: $route.path === '/shifts1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#f59e0b"></span>Shifts</router-link>
        <router-link to="/users1" class="c1-td-nav-item" :class="{ on: $route.path === '/users1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#06b6d4"></span>Users</router-link>
        <router-link to="/brokers1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#ec4899"></span>Brokers</router-link>
        <router-link to="/security1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#ef4444"></span>Security</router-link>
        <router-link to="/quiz1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#a78bfa"></span>Quiz</router-link>
        <router-link to="/instruction1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#64748b"></span>Instructions</router-link>
        <router-link to="/settings1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#94a3b8"></span>Settings</router-link>
        <router-link to="/profile1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#22d3ee"></span>My Profile</router-link>
      </div>
    </div>
    </div><!-- /c1-sticky-top -->

    <!-- TOP STRIP (filter tabs - always visible) -->
    <div class="c1-top-strip c1-mod-strip" @click.stop>
      <div class="c1-top-strip-body">
        <div class="c1-ts-tab-row">
          <!-- Teams Management tab — FIRST so always visible -->
          <div class="c1-ts-tab u1-teams-tab" :class="{on: c1TopTab === 'teams'}" @click.stop="c1TopTab = c1TopTab === 'teams' ? null : 'teams'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
            <span>Teams</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='teams' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
          <div class="c1-ts-tab-sep"></div>
          <!-- Add User tab — SECOND so always visible -->
          <div class="c1-ts-tab u1-add-tab" :class="{on: c1TopTab === 'adduser'}" @click.stop="c1TopTab = c1TopTab === 'adduser' ? null : 'adduser'; u1AddError = ''; u1AddOk = ''">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
            <span>+ User</span>
          </div>
          <div class="c1-ts-tab-sep"></div>
          <!-- Role tab -->
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'role'}" @click.stop="c1TopTab = c1TopTab === 'role' ? null : 'role'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
            <span>Role</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='role' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
          <div class="c1-ts-tab-sep"></div>
          <!-- Status tab -->
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'status'}" @click.stop="c1TopTab = c1TopTab === 'status' ? null : 'status'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
            <span>Status</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='status' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
          <div class="c1-ts-tab-sep"></div>
          <!-- Team filter tab -->
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'team'}" @click.stop="c1TopTab = c1TopTab === 'team' ? null : 'team'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/></svg>
            <span>Filter</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='team' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
          <div class="c1-ts-tab-sep"></div>
          <!-- Search tab -->
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'search'}" @click.stop="c1TopTab = c1TopTab === 'search' ? null : 'search'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
            <span>Search</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='search' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
          <div class="c1-ts-tab-sep"></div>
          <!-- Charts tab -->
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'charts'}" @click.stop="c1TopTab = c1TopTab === 'charts' ? null : 'charts'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>
            <span>Charts</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='charts' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
        </div>

        <!-- Role dropdown -->
        <div v-show="c1TopTab === 'role'" class="c1-ts-dropdown" @click.stop>
          <div class="c1-fp-group">
            <div class="c1-fp-lbl">Role</div>
            <div class="c1-fp-opts">
              <div class="c1-fp-opt" :class="{ on: u1Filters.role === null }" @click="u1SetRoleFilter(null)">
                All <span class="c1-fc">{{ u1Users.length }}</span>
              </div>
              <div class="c1-fp-opt u1-role-admin" :class="{ on: u1Filters.role === 1 }" @click="u1SetRoleFilter(1)">
                Admin <span class="c1-fc">{{ u1CountByRole(1) }}</span>
              </div>
              <div class="c1-fp-opt u1-role-manager" :class="{ on: u1Filters.role === 4 }" @click="u1SetRoleFilter(4)">
                Manager <span class="c1-fc">{{ u1CountByRole(4) }}</span>
              </div>
              <div class="c1-fp-opt u1-role-agent" :class="{ on: u1Filters.role === 7 }" @click="u1SetRoleFilter(7)">
                Agent <span class="c1-fc">{{ u1CountByRole(7) }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Status dropdown -->
        <div v-show="c1TopTab === 'status'" class="c1-ts-dropdown" @click.stop>
          <div class="c1-fp-group">
            <div class="c1-fp-lbl">Status</div>
            <div class="c1-fp-opts">
              <div class="c1-fp-opt" :class="{ on: u1Filters.active === null }" @click="u1Filters.active = null">All</div>
              <div class="c1-fp-opt u1-status-active" :class="{ on: u1Filters.active === true }" @click="u1Filters.active = true">Active</div>
              <div class="c1-fp-opt u1-status-inactive" :class="{ on: u1Filters.active === false }" @click="u1Filters.active = false">Inactive</div>
            </div>
          </div>
        </div>

        <!-- Team dropdown -->
        <div v-show="c1TopTab === 'team'" class="c1-ts-dropdown" @click.stop>
          <div class="c1-fp-group c1-fp-full">
            <div class="c1-fp-lbl">Team</div>
            <div class="c1-fp-opts">
              <div class="c1-fp-opt" :class="{ on: u1Filters.team === null }" @click="u1Filters.team = null">All teams</div>
              <div
                v-for="team in u1Teams"
                :key="team"
                class="c1-fp-opt"
                :class="{ on: u1Filters.team === team }"
                @click="u1Filters.team = team"
              >{{ team }}</div>
            </div>
          </div>
        </div>

        <!-- Search dropdown -->
        <div v-show="c1TopTab === 'search'" class="c1-ts-dropdown" @click.stop>
          <div class="c1-fp-group c1-fp-full">
            <div class="c1-fp-lbl">Search</div>
            <div class="c1-fp-search">
              <svg class="c1-fp-sico" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
              <input class="c1-fp-sinput" v-model.trim="u1Filters.search" placeholder="Name, email…" type="text" />
              <div v-if="u1Filters.search" class="c1-fp-sclear" @click="u1Filters.search = ''">
                <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </div>
            </div>
          </div>
        </div>

        <!-- Charts dropdown -->
        <div v-show="c1TopTab === 'charts'" class="c1-ts-dropdown" @click.stop>
          <div class="c1-co-lbl" style="width:100%">Team Overview</div>
          <div class="c1-kpi-row" style="width:100%">
            <div class="c1-kpi"><div class="c1-kpi-lbl">Total Agents</div><div class="c1-kpi-val" style="color:var(--c1-dp)">{{ u1CountByRole(7) }}</div></div>
            <div class="c1-kpi"><div class="c1-kpi-lbl">Managers</div><div class="c1-kpi-val" style="color:var(--c1-sc)">{{ u1CountByRole(4) }}</div></div>
            <div class="c1-kpi"><div class="c1-kpi-lbl">Online Now</div><div class="c1-kpi-val" style="color:var(--c1-ac)">{{ u1OnlineCount }}</div></div>
            <div class="c1-kpi"><div class="c1-kpi-lbl">Active</div><div class="c1-kpi-val">{{ u1ActiveCount }}</div></div>
          </div>
          <div class="c1-co-lbl" style="width:100%;margin-top:14px">Deposits This Month — Per Agent</div>
          <div class="c1-vbar-chart" style="width:100%">
            <div v-for="bar in u1DepositBars" :key="bar.label" class="c1-vbar-row">
              <div class="c1-vbar-lbl">{{ bar.label }}</div>
              <div class="c1-vbar-track">
                <div class="c1-vbar-fill u1-bar-dp" :style="{ width: bar.pct + '%' }"><span class="c1-vbar-val">{{ bar.val }}</span></div>
              </div>
            </div>
          </div>
          <div class="c1-co-lbl" style="width:100%;margin-top:14px">Leads This Month — Per Agent</div>
          <div class="c1-vbar-chart" style="width:100%">
            <div v-for="bar in u1LeadBars" :key="bar.label" class="c1-vbar-row">
              <div class="c1-vbar-lbl">{{ bar.label }}</div>
              <div class="c1-vbar-track">
                <div class="c1-vbar-fill u1-bar-ld" :style="{ width: bar.pct + '%' }"><span class="c1-vbar-val">{{ bar.val }}</span></div>
              </div>
            </div>
          </div>
          <div class="c1-co-lbl" style="width:100%;margin-top:14px">Current Load — Active Clients Per Agent</div>
          <div class="c1-vbar-chart" style="width:100%">
            <div v-for="bar in u1LoadBars" :key="bar.label" class="c1-vbar-row">
              <div class="c1-vbar-lbl">{{ bar.label }}</div>
              <div class="c1-vbar-track">
                <div class="c1-vbar-fill u1-bar-load" :style="{ width: bar.pct + '%', background: bar.color }"><span class="c1-vbar-val">{{ bar.val }}</span></div>
              </div>
            </div>
          </div>
        </div>

        <!-- Add User dropdown -->
        <div v-show="c1TopTab === 'adduser'" class="c1-ts-dropdown u1-adduser-dropdown" @click.stop>
          <div class="u1-au-body">

            <!-- LEFT: Avatar -->
            <div class="u1-au-avatar-col">
              <div class="u1-au-avatar-preview" :style="{ background: u1NewUser.avatarColor }">
                <img v-if="u1NewUser.avatarDataUrl" :src="u1NewUser.avatarDataUrl" class="u1-au-avatar-img" />
                <span v-else class="u1-au-avatar-initials">{{ u1AuInitials }}</span>
              </div>
              <div class="u1-au-avatar-colors">
                <div v-for="c in u1AvatarPalette" :key="c" class="u1-au-color-dot" :class="{active: u1NewUser.avatarColor === c}" :style="{background: c}" @click="u1NewUser.avatarColor = c; u1NewUser.avatarDataUrl = null"></div>
              </div>
              <label class="u1-au-upload-btn">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:11px;height:11px"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
                Upload photo
                <input type="file" accept="image/*" style="display:none" @change="u1AuPickImage" />
              </label>
            </div>

            <!-- RIGHT: Fields -->
            <div class="u1-au-fields-col">
              <div class="u1-au-row">
                <div class="u1-au-field">
                  <label class="u1-au-lbl">First Name *</label>
                  <input class="u1-au-input" v-model.trim="u1NewUser.first_name" placeholder="First name" type="text" />
                </div>
                <div class="u1-au-field">
                  <label class="u1-au-lbl">Last Name *</label>
                  <input class="u1-au-input" v-model.trim="u1NewUser.last_name" placeholder="Last name" type="text" />
                </div>
              </div>
              <div class="u1-au-row">
                <div class="u1-au-field">
                  <label class="u1-au-lbl">Username * <span class="u1-au-hint">(used for login &amp; emails)</span></label>
                  <input class="u1-au-input" v-model.trim="u1NewUser.username_special" placeholder="e.g. john.smith" type="text" />
                </div>
                <div class="u1-au-field">
                  <label class="u1-au-lbl">Email *</label>
                  <input class="u1-au-input" v-model.trim="u1NewUser.email" placeholder="email@company.com" type="email" />
                </div>
              </div>
              <div class="u1-au-row">
                <div class="u1-au-field">
                  <label class="u1-au-lbl">Password *</label>
                  <input class="u1-au-input" v-model="u1NewUser.password" placeholder="Min 6 chars" type="password" />
                </div>
                <div class="u1-au-field">
                  <label class="u1-au-lbl">Confirm *</label>
                  <input class="u1-au-input" v-model="u1NewUser.rePassword" placeholder="Re-enter" type="password" />
                </div>
              </div>
              <div class="u1-au-row">
                <div class="u1-au-field">
                  <label class="u1-au-lbl">Team *</label>
                  <div class="u1-au-pill-row">
                    <div class="u1-au-pill" :class="{on: u1NewUser.team_id === 1}" @click="u1NewUser.team_id = 1">Team 1</div>
                    <div class="u1-au-pill" :class="{on: u1NewUser.team_id === 2}" @click="u1NewUser.team_id = 2">Team 2</div>
                  </div>
                </div>
                <div class="u1-au-field">
                  <label class="u1-au-lbl">VoIP Ext</label>
                  <input class="u1-au-input" v-model.trim="u1NewUser.voip_user" placeholder="e.g. 201" type="text" />
                </div>
              </div>
              <!-- Role pills -->
              <div class="u1-au-field u1-au-field-full">
                <label class="u1-au-lbl">Role *</label>
                <div class="u1-au-role-grid">
                  <div
                    v-for="r in u1RoleOptions" :key="r.id"
                    class="u1-au-role-pill"
                    :class="{ on: u1NewUser.role === r.id }"
                    :style="u1NewUser.role === r.id ? { background: r.color, borderColor: r.color, color:'#fff' } : { borderColor: r.color, color: r.color }"
                    @click="u1NewUser.role = r.id"
                  >{{ r.label }}</div>
                </div>
              </div>
              <!-- Permissions -->
              <div class="u1-au-checks">
                <label class="u1-check-lbl"><input type="checkbox" v-model="u1NewUser.active" /> Active</label>
                <label class="u1-check-lbl"><input type="checkbox" v-model="u1NewUser.stats_active" /> Statistics</label>
                <label class="u1-check-lbl"><input type="checkbox" v-model="u1NewUser.reports_active" /> Reports</label>
              </div>
            </div>
          </div>

          <div v-if="u1AddError" class="u1-au-err">{{ u1AddError }}</div>
          <div v-if="u1AddOk" class="u1-au-ok">{{ u1AddOk }}</div>
          <button
            class="u1-au-btn"
            :disabled="!u1NewUser.first_name || !u1NewUser.last_name || !u1NewUser.email || !u1NewUser.username_special || !u1NewUser.role || !u1NewUser.team_id || !u1NewUser.password || u1AddLoading"
            @click="u1SubmitNewUser"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:13px;height:13px"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
            {{ u1AddLoading ? 'Creating…' : 'Create User' }}
          </button>
        </div>

        <!-- Teams Management dropdown -->
        <div v-show="c1TopTab === 'teams'" class="c1-ts-dropdown u1-teams-dropdown" @click.stop>
          <!-- Header row -->
          <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:4px;">
            <div style="font-size:13px;font-weight:700;color:var(--u1-t1);">Teams</div>
            <button class="u1-team-btn u1-team-btn-primary" style="padding:5px 14px;border-radius:7px;font-size:11px;font-weight:600;cursor:pointer;" @click="u1TeamsForm = { show: true, editId: null, title: '', color: '#0e7490', emoji: '⚡', manager_id: null }">+ Create Team</button>
          </div>

          <!-- Loading -->
          <div v-if="u1TeamsLoading" style="padding:18px 0;text-align:center;color:var(--u1-t3);font-size:12px;">Loading teams…</div>

          <!-- Team cards -->
          <div v-else class="u1-team-cards">
            <div
              v-for="team in u1TeamsList"
              :key="team.id"
              class="u1-team-card"
              :style="{ '--tc': team.color }"
            >
              <div class="u1-team-card-head">
                <span class="u1-team-emoji">{{ team.emoji || '👥' }}</span>
                <span class="u1-team-name">{{ team.title }}</span>
              </div>
              <div class="u1-team-mgr">Manager: {{ u1TeamManagerName(team.manager_id) }}</div>
              <div class="u1-team-count">{{ u1TeamMemberCount(team.id) }} members</div>
              <div class="u1-team-actions">
                <button class="u1-team-btn u1-team-btn-primary" @click="u1FilterByTeam(team.id)">Filter</button>
                <button class="u1-team-btn" @click="u1TeamsForm = { show: true, editId: team.id, title: team.title, color: team.color || '#0e7490', emoji: team.emoji || '⚡', manager_id: team.manager_id }">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:11px;height:11px"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                </button>
                <button v-if="u1TeamMemberCount(team.id) === 0" class="u1-team-btn" style="color:#ef4444;" @click="u1DeleteTeam(team.id)">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:11px;height:11px"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>
                </button>
              </div>
            </div>

            <!-- Empty state when no teams -->
            <div v-if="u1TeamsList.length === 0" style="color:var(--u1-t3);font-size:12px;padding:16px 0;">No teams yet. Create your first team.</div>
          </div>

          <!-- Create / Edit form -->
          <div v-if="u1TeamsForm.show" class="u1-team-form">
            <div class="u1-tf-row">
              <div class="u1-tf-field">
                <div class="u1-tf-lbl">Team Name</div>
                <input class="u1-tf-input" v-model.trim="u1TeamsForm.title" placeholder="e.g. Sales A" />
              </div>
              <div class="u1-tf-field" style="flex:0 0 60px;">
                <div class="u1-tf-lbl">Emoji</div>
                <input class="u1-tf-input" v-model.trim="u1TeamsForm.emoji" placeholder="⚡" style="text-align:center;font-size:18px;" />
              </div>
            </div>
            <div class="u1-tf-row">
              <div class="u1-tf-field">
                <div class="u1-tf-lbl">Color</div>
                <div class="u1-tf-colors">
                  <div
                    v-for="c in u1TeamsColorPalette"
                    :key="c"
                    class="u1-tf-color-swatch"
                    :class="{ active: u1TeamsForm.color === c }"
                    :style="{ background: c }"
                    @click="u1TeamsForm.color = c"
                  ></div>
                </div>
              </div>
              <div class="u1-tf-field">
                <div class="u1-tf-lbl">Manager</div>
                <select class="u1-tf-select" v-model="u1TeamsForm.manager_id">
                  <option :value="null">None</option>
                  <option v-for="u in u1Users" :key="u.id" :value="u.id">{{ u.first_name }} {{ u.last_name }}</option>
                </select>
              </div>
            </div>
            <div class="u1-tf-actions">
              <button class="u1-tf-btn u1-tf-btn-save" :disabled="u1TeamsFormSaving || !u1TeamsForm.title" @click="u1SaveTeam">
                {{ u1TeamsFormSaving ? 'Saving…' : (u1TeamsForm.editId ? 'Update Team' : 'Create Team') }}
              </button>
              <button class="u1-tf-btn u1-tf-btn-cancel" @click="u1TeamsForm.show = false">Cancel</button>
            </div>
          </div>
        </div>

        <div class="c1-nm-div"></div>
        <c1-mod-calendar :items="u1Users" dateField="created_at" itemLabel="users" style="flex-shrink:0" />

      </div>
    </div>
    <!-- /TOP STRIP -->

    <!-- PANEL BACKDROP -->
    <transition name="c1-bd-fade">
      <div v-if="c1SlideOpen" class="c1-panel-backdrop" @click.stop="c1SlideOpen = null"></div>
    </transition>

    <!-- UNIFIED PANEL -->
    <div class="c1-panel" :class="{ 'c1-panel--open': c1PanelIsOpen }" @click.capture="c1FilterPanelClick">
      <div class="c1-panel-track" :class="{ 'at-content': c1PanelAtContent }">

        <!-- SCREEN 0: NAV -->
        <div class="c1-panel-screen">
          <!-- ── USER STRIP ── -->
          <div class="c1-nav-user-strip">
            <div class="c1-nav-av">
              {{ c1UserInitials }}
              <span class="c1-nav-av-dot" :class="'c1-dst-' + c1Status"></span>
            </div>
            <div class="c1-nav-uinfo">
              <div class="c1-nav-uname">{{ c1UserFullName }}</div>
              <div class="c1-nav-urole">{{ c1RoleLabel }}</div>
            </div>
            <div class="c1-nav-status-wrap" @click.stop="c1StatusMenuOpen = !c1StatusMenuOpen">
              <div class="c1-nav-status-btn" :class="'c1-st-' + c1Status">
                <span class="c1-nav-status-sdot"></span>
                <span class="c1-nav-status-elapsed">{{ c1StatusElapsed }}</span>
              </div>
              <transition name="c1-sfade">
                <div v-if="c1StatusMenuOpen" class="c1-nav-status-menu">
                  <div class="c1-nav-status-opt" @click.stop="c1SetStatus('available')"><span class="c1-nav-status-opt-dot c1-st-dot-available"></span>Available</div>
                  <div class="c1-nav-status-opt" @click.stop="c1SetStatus('bathroom')"><span class="c1-nav-status-opt-dot c1-st-dot-bathroom"></span>Bathroom</div>
                  <div class="c1-nav-status-opt" @click.stop="c1SetStatus('coffee')"><span class="c1-nav-status-opt-dot c1-st-dot-coffee"></span>Coffee break</div>
                  <div class="c1-nav-status-opt" @click.stop="c1SetStatus('shift')"><span class="c1-nav-status-opt-dot c1-st-dot-shift"></span>Start shift</div>
                  <div class="c1-nav-status-opt c1-sto-end" @click.stop="c1SetStatus('end')"><span class="c1-nav-status-opt-dot c1-st-dot-end"></span>End shift</div>
                </div>
              </transition>
            </div>
          </div>

          <!-- ── TIMEZONE BAR ── -->
          <div class="c1-nav-tz-bar">
            <div class="c1-nav-tz-cell"><span class="c1-nav-tz-flag">🇬🇧</span><span class="c1-nav-tz-time">{{ c1TzUK }}</span></div>
            <div class="c1-nav-tz-sep"></div>
            <div class="c1-nav-tz-cell"><span class="c1-nav-tz-flag">🇮🇱</span><span class="c1-nav-tz-time">{{ c1TzIL }}</span></div>
            <div class="c1-nav-tz-sep"></div>
            <div class="c1-nav-tz-cell"><span class="c1-nav-tz-flag">🏝</span><span class="c1-nav-tz-time">{{ c1TzCB }}</span></div>
          </div>

          <!-- ── NAVIGATE: all pages ── -->
          <div v-if="c1NavMode === 'navigate'" class="c1-sl-body" style="padding:6px 0 12px">
            <div class="c1-psel-sub c1-psel-sub-back" @click.stop="c1NavMode = 'panels'">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:14px;height:14px;flex-shrink:0"><polyline points="15 18 9 12 15 6"/></svg>
              <span class="c1-psel-sub-lbl">{{ c1CurrentPageLabel }}</span>
            <span class="c1-nav-x-btn" @click.stop="c1SlideOpen = null"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:15px;height:15px;display:block"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></span></div>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">CRM</div>
            <router-link class="c1-psel-sub" to="/clients1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Clients</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/tasks1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Tasks</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/stats1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Statistics</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/chat1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Chat</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/communications1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Communications</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/affiliation1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Affiliation</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">Sales</div>
            <router-link class="c1-psel-sub" to="/finance1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-sc)"></span><span class="c1-psel-sub-lbl">Finance</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/shifts1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-sc)"></span><span class="c1-psel-sub-lbl">Shifts</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/games1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-sc)"></span><span class="c1-psel-sub-lbl">Games</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">Team</div>
            <router-link class="c1-psel-sub" to="/users1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-rf)"></span><span class="c1-psel-sub-lbl">Users</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/brokers1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-rf)"></span><span class="c1-psel-sub-lbl">Brokers</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/security1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-rf)"></span><span class="c1-psel-sub-lbl">Security</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">Admin</div>
            <router-link class="c1-psel-sub" to="/quiz1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:#7c6f9f"></span><span class="c1-psel-sub-lbl">Quiz</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/instruction1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:#7c6f9f"></span><span class="c1-psel-sub-lbl">Instructions</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/settings1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:#7c6f9f"></span><span class="c1-psel-sub-lbl">Settings</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/profile1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">My Profile</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
          </div>

          <!-- ── PANELS MODE ── -->
          <div v-else class="c1-sl-body" style="padding:6px 0 12px">

            <!-- Navigate row -->
            <div class="c1-psel-sub c1-psel-sub-navigate" @click.stop="c1NavMode = 'navigate'">
              <span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span>
              <span class="c1-psel-sub-lbl" style="font-weight:600;color:var(--c1-dp)">{{ c1CurrentPageLabel }}</span>
              <span class="c1-psel-sub-hint">Go to another page</span>
              <svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-divider"></div>

            <div class="c1-psel-sub" @click="c1SelectPanel('filters')">
              <span class="c1-psel-sub-dot">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:13px;height:13px"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg>
              </span>
              <span class="c1-psel-sub-lbl">Filters</span>
              <svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-sub" @click="c1SelectPanel('charts')">
              <span class="c1-psel-sub-dot">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:13px;height:13px"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>
              </span>
              <span class="c1-psel-sub-lbl">Charts</span>
              <svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-sub" @click="c1SelectPanel('calendar')">
              <span class="c1-psel-sub-dot">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:13px;height:13px"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
              </span>
              <span class="c1-psel-sub-lbl">Calendar</span>
              <svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-sub" @click="c1SelectPanel('viki')">
              <span class="c1-psel-sub-dot">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:13px;height:13px"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
              </span>
              <span class="c1-psel-sub-lbl">Viki</span>
              <span v-if="u1VikiUnread" class="c1-psel-sub-hint">unread</span>
              <svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-sub" @click="c1SelectPanel('add')">
              <span class="c1-psel-sub-dot">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:13px;height:13px"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
              </span>
              <span class="c1-psel-sub-lbl">Add User</span>
              <svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
          </div><!-- end v-else panels -->
        </div>

        <!-- SCREEN 1: CONTENT -->
        <div class="c1-panel-screen">
          <div class="c1-panel-hdr-bar">
            <div class="c1-panel-back-btn" @click="c1SlideOpen = 'nav'">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
            </div>
            <span class="c1-panel-hdr-ttl">{{ c1ActivePanelLabel }}</span>
            <div class="c1-panel-back-btn" @click="c1SlideOpen = null">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </div>
          </div>
          <div class="c1-sl-body">

            <!-- ═══ FILTERS CONTENT ═══ -->
            <template v-if="c1PanelActiveContent === 'filters'">
              <!-- Role filter -->
              <div class="c1-fp-group">
                <div class="c1-fp-lbl">Role</div>
                <div class="c1-fp-opts">
                  <div class="c1-fp-opt" :class="{ on: u1Filters.role === null }" @click="u1SetRoleFilter(null)">
                    All <span class="c1-fc">{{ u1Users.length }}</span>
                  </div>
                  <div class="c1-fp-opt u1-role-admin" :class="{ on: u1Filters.role === 1 }" @click="u1SetRoleFilter(1)">
                    Admin <span class="c1-fc">{{ u1CountByRole(1) }}</span>
                  </div>
                  <div class="c1-fp-opt u1-role-manager" :class="{ on: u1Filters.role === 4 }" @click="u1SetRoleFilter(4)">
                    Manager <span class="c1-fc">{{ u1CountByRole(4) }}</span>
                  </div>
                  <div class="c1-fp-opt u1-role-agent" :class="{ on: u1Filters.role === 7 }" @click="u1SetRoleFilter(7)">
                    Agent <span class="c1-fc">{{ u1CountByRole(7) }}</span>
                  </div>
                </div>
              </div>
              <!-- Status filter -->
              <div class="c1-fp-group">
                <div class="c1-fp-lbl">Status</div>
                <div class="c1-fp-opts">
                  <div class="c1-fp-opt" :class="{ on: u1Filters.active === null }" @click="u1Filters.active = null">All</div>
                  <div class="c1-fp-opt u1-status-active" :class="{ on: u1Filters.active === true }" @click="u1Filters.active = true">Active</div>
                  <div class="c1-fp-opt u1-status-inactive" :class="{ on: u1Filters.active === false }" @click="u1Filters.active = false">Inactive</div>
                </div>
              </div>
              <!-- Team filter -->
              <div class="c1-fp-group c1-fp-full">
                <div class="c1-fp-lbl">Team</div>
                <div class="c1-fp-opts">
                  <div class="c1-fp-opt" :class="{ on: u1Filters.team === null }" @click="u1Filters.team = null">All teams</div>
                  <div
                    v-for="team in u1Teams"
                    :key="team"
                    class="c1-fp-opt"
                    :class="{ on: u1Filters.team === team }"
                    @click="u1Filters.team = team"
                  >{{ team }}</div>
                </div>
              </div>
              <!-- Search -->
              <div class="c1-fp-group c1-fp-full">
                <div class="c1-fp-lbl">Search</div>
                <div class="c1-fp-search">
                  <svg class="c1-fp-sico" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
                  <input class="c1-fp-sinput" v-model.trim="u1Filters.search" placeholder="Name, email…" type="text" />
                  <div v-if="u1Filters.search" class="c1-fp-sclear" @click="u1Filters.search = ''">
                    <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                  </div>
                </div>
              </div>
            </template>

            <!-- ═══ CHARTS CONTENT ═══ -->
            <template v-if="c1PanelActiveContent === 'charts'">
              <!-- KPI row -->
              <div class="c1-co-lbl" style="width:100%">Team Overview</div>
              <div class="c1-kpi-row" style="width:100%">
                <div class="c1-kpi">
                  <div class="c1-kpi-lbl">Total Agents</div>
                  <div class="c1-kpi-val" style="color:var(--c1-dp)">{{ u1CountByRole(7) }}</div>
                </div>
                <div class="c1-kpi">
                  <div class="c1-kpi-lbl">Managers</div>
                  <div class="c1-kpi-val" style="color:var(--c1-sc)">{{ u1CountByRole(5) }}</div>
                </div>
                <div class="c1-kpi">
                  <div class="c1-kpi-lbl">Online Now</div>
                  <div class="c1-kpi-val" style="color:var(--c1-ac)">{{ u1OnlineCount }}</div>
                </div>
                <div class="c1-kpi">
                  <div class="c1-kpi-lbl">Active</div>
                  <div class="c1-kpi-val">{{ u1ActiveCount }}</div>
                </div>
              </div>

              <!-- Deposits per agent bar chart -->
              <div class="c1-co-lbl" style="width:100%;margin-top:14px">Deposits This Month — Per Agent</div>
              <div class="c1-vbar-chart" style="width:100%">
                <div v-for="bar in u1DepositBars" :key="bar.label" class="c1-vbar-row">
                  <div class="c1-vbar-lbl">{{ bar.label }}</div>
                  <div class="c1-vbar-track">
                    <div class="c1-vbar-fill u1-bar-dp" :style="{ width: bar.pct + '%' }">
                      <span class="c1-vbar-val">{{ bar.val }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Leads per agent -->
              <div class="c1-co-lbl" style="width:100%;margin-top:14px">Leads This Month — Per Agent</div>
              <div class="c1-vbar-chart" style="width:100%">
                <div v-for="bar in u1LeadBars" :key="bar.label" class="c1-vbar-row">
                  <div class="c1-vbar-lbl">{{ bar.label }}</div>
                  <div class="c1-vbar-track">
                    <div class="c1-vbar-fill u1-bar-ld" :style="{ width: bar.pct + '%' }">
                      <span class="c1-vbar-val">{{ bar.val }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Current load: active clients per agent -->
              <div class="c1-co-lbl" style="width:100%;margin-top:14px">Current Load — Active Clients Per Agent</div>
              <div class="c1-vbar-chart" style="width:100%">
                <div v-for="bar in u1LoadBars" :key="bar.label" class="c1-vbar-row">
                  <div class="c1-vbar-lbl">{{ bar.label }}</div>
                  <div class="c1-vbar-track">
                    <div class="c1-vbar-fill u1-bar-load" :style="{ width: bar.pct + '%', background: bar.color }">
                      <span class="c1-vbar-val">{{ bar.val }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </template>

            <!-- ═══ CALENDAR CONTENT ═══ -->
            <template v-if="c1PanelActiveContent === 'calendar'">
              <div class="u1-cal-head">
                <button class="u1-cal-nav" @click="u1CalPrev">
                  <svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"/></svg>
                </button>
                <span class="u1-cal-title">{{ u1CalMonthNames[u1Cal.month] }} {{ u1Cal.year }}</span>
                <button class="u1-cal-nav" @click="u1CalNext">
                  <svg viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"/></svg>
                </button>
              </div>
              <div class="u1-cal-grid">
                <div class="u1-cal-dh" v-for="d in ['Mo','Tu','We','Th','Fr','Sa','Su']" :key="d">{{ d }}</div>
                <template v-for="week in u1CalGrid">
                  <div
                    v-for="day in week"
                    :key="day.date"
                    class="u1-cal-day"
                    :class="{
                      'u1-cal-oom': !day.inMonth,
                      'u1-cal-today': day.today,
                      'u1-cal-sel': u1SelectedDay === day.date
                    }"
                    @click="u1SelectDay(day)"
                  >
                    <span>{{ day.day }}</span>
                    <div v-if="day.inMonth" class="u1-cal-dot"></div>
                  </div>
                </template>
              </div>

              <!-- Who was on shift -->
              <div v-if="u1SelectedDay" class="u1-att-section">
                <div class="c1-co-lbl">On Shift — {{ u1SelectedDay }}</div>
                <div v-if="u1AttLoading" class="u1-att-spin"><div class="c1-spinner"></div></div>
                <div v-else-if="u1AttendeesFinal.length === 0" class="u1-att-empty">No attendance data for this day.</div>
                <div v-else class="u1-att-list">
                  <div v-for="att in u1AttendeesFinal" :key="att.id" class="u1-att-row">
                    <div class="u1-av" :style="{ background: u1AvatarColor(att.id) }">{{ u1Initials(att) }}</div>
                    <div class="u1-att-name">{{ att.first_name }} {{ att.last_name }}</div>
                    <div class="u1-role-badge" :class="'u1-role-' + att.role_id">{{ u1RoleLabel(att.role_id) }}</div>
                    <div v-if="att.shift_start" class="u1-att-time">{{ att.shift_start }} – {{ att.shift_end || '?' }}</div>
                  </div>
                </div>
              </div>
              <div v-else class="u1-att-hint">Click a day to see who was on shift.</div>
            </template>

            <!-- ═══ ADD USER CONTENT ═══ -->
            <template v-if="c1PanelActiveContent === 'add'">
              <div class="c1-co-lbl">Add New User</div>
              <div class="u1-form-grid">
                <div class="u1-form-group">
                  <label class="u1-form-lbl">First Name *</label>
                  <input class="u1-form-input" v-model.trim="u1NewUser.first_name" placeholder="First name" type="text" />
                </div>
                <div class="u1-form-group">
                  <label class="u1-form-lbl">Last Name *</label>
                  <input class="u1-form-input" v-model.trim="u1NewUser.last_name" placeholder="Last name" type="text" />
                </div>
                <div class="u1-form-group u1-form-full">
                  <label class="u1-form-lbl">Email *</label>
                  <input class="u1-form-input" v-model.trim="u1NewUser.email" placeholder="email@company.com" type="email" />
                </div>
                <div class="u1-form-group u1-form-full">
                  <label class="u1-form-lbl">Password *</label>
                  <input class="u1-form-input" v-model="u1NewUser.password" placeholder="Enter password" type="password" />
                </div>
                <div class="u1-form-group u1-form-full">
                  <label class="u1-form-lbl">Confirm Password *</label>
                  <input class="u1-form-input" v-model="u1NewUser.rePassword" placeholder="Re-enter password" type="password" />
                </div>
                <div class="u1-form-group u1-form-full">
                  <label class="u1-form-lbl">Role *</label>
                  <select class="u1-form-select" v-model="u1NewUser.role">
                    <option :value="null" disabled>Select role…</option>
                    <option v-for="r in u1RoleOptions" :key="r.id" :value="r.id">{{ r.label }}</option>
                  </select>
                </div>
                <div class="u1-form-group u1-form-full">
                  <label class="u1-form-lbl">Team *</label>
                  <select class="u1-form-select" v-model="u1NewUser.team_id">
                    <option :value="null" disabled>Select team…</option>
                    <option :value="1">Team 1</option>
                    <option :value="2">Team 2</option>
                  </select>
                </div>
                <div class="u1-form-group u1-form-full">
                  <label class="u1-form-lbl">VoIP Extension</label>
                  <input class="u1-form-input" v-model.trim="u1NewUser.voip_user" placeholder="e.g. 201" type="text" />
                </div>
                <div class="u1-form-group u1-form-full">
                  <label class="u1-form-lbl" style="margin-bottom:8px">Permissions</label>
                  <div class="u1-check-row">
                    <label class="u1-check-lbl">
                      <input type="checkbox" v-model="u1NewUser.active" /> Active
                    </label>
                    <label class="u1-check-lbl">
                      <input type="checkbox" v-model="u1NewUser.stats_active" /> Statistics
                    </label>
                    <label class="u1-check-lbl">
                      <input type="checkbox" v-model="u1NewUser.reports_active" /> Reports
                    </label>
                  </div>
                </div>
              </div>
              <div v-if="u1AddError" class="u1-form-err">{{ u1AddError }}</div>
              <div v-if="u1AddOk" class="u1-form-ok">{{ u1AddOk }}</div>
              <button
                class="u1-submit-btn"
                :disabled="!u1NewUser.first_name || !u1NewUser.last_name || !u1NewUser.email || !u1NewUser.role || !u1NewUser.team_id || !u1NewUser.password || u1AddLoading"
                @click="u1SubmitNewUser"
              >
                <svg viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                {{ u1AddLoading ? 'Creating…' : 'Create User' }}
              </button>

              <!-- Bulk reassign -->
              <div class="c1-co-lbl" style="margin-top:20px">Bulk Reassign Clients</div>
              <div class="u1-bulk-row">
                <div class="u1-form-group u1-form-half">
                  <label class="u1-form-lbl">From Agent</label>
                  <select class="u1-form-select" v-model="u1Bulk.from_id">
                    <option :value="null" disabled>Select agent…</option>
                    <option v-for="u in u1Agents" :key="u.id" :value="u.id">{{ u.first_name }} {{ u.last_name }}</option>
                  </select>
                </div>
                <div class="u1-bulk-arrow">
                  <svg viewBox="0 0 24 24"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
                </div>
                <div class="u1-form-group u1-form-half">
                  <label class="u1-form-lbl">To Agent</label>
                  <select class="u1-form-select" v-model="u1Bulk.to_id">
                    <option :value="null" disabled>Select agent…</option>
                    <option v-for="u in u1Agents" :key="u.id" :value="u.id" :disabled="u.id === u1Bulk.from_id">{{ u.first_name }} {{ u.last_name }}</option>
                  </select>
                </div>
              </div>
              <div v-if="u1BulkMsg" class="u1-form-ok">{{ u1BulkMsg }}</div>
              <button
                class="u1-submit-btn u1-submit-bulk"
                :disabled="!u1Bulk.from_id || !u1Bulk.to_id || u1BulkLoading"
                @click="u1SubmitBulkReassign"
              >
                <svg viewBox="0 0 24 24"><polyline points="17 1 21 5 17 9"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><polyline points="7 23 3 19 7 15"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/></svg>
                {{ u1BulkLoading ? 'Reassigning…' : 'Reassign All Clients' }}
              </button>
            </template>

          </div>
        </div>

      </div>
    </div>

    <!-- LOADING STATE -->
    <div v-if="u1Loading" class="u1-loading">
      <div class="c1-spinner"></div>
      <span>Loading users…</span>
    </div>

    <!-- ROLE FILTER BADGES + USER LIST wrapper -->
    <div v-else class="u1-list-wrap">

      <!-- Role filter chips -->
      <div class="u1-role-filter-bar">
        <div class="u1-rfb-chip" :class="{ on: u1Filters.role === null }" @click="u1SetRoleFilter(null)">
          All <span class="u1-rfb-count">{{ u1Users.length }}</span>
        </div>
        <div class="u1-rfb-chip u1-rfb-admin" :class="{ on: u1Filters.role === 1 }" @click="u1SetRoleFilter(1)">
          Admin <span class="u1-rfb-count">{{ u1CountByRole(1) }}</span>
        </div>
        <div class="u1-rfb-chip u1-rfb-manager" :class="{ on: u1Filters.role === 4 }" @click="u1SetRoleFilter(4)">
          Manager <span class="u1-rfb-count">{{ u1CountByRole(4) }}</span>
        </div>
        <div class="u1-rfb-chip u1-rfb-agent" :class="{ on: u1Filters.role === 7 }" @click="u1SetRoleFilter(7)">
          Agent <span class="u1-rfb-count">{{ u1CountByRole(7) }}</span>
        </div>
        <div class="u1-rfb-chip u1-rfb-chat" :class="{ on: u1Filters.role === 5 }" @click="u1SetRoleFilter(5)">
          Chat Agent <span class="u1-rfb-count">{{ u1CountByRole(5) }}</span>
        </div>
      </div>

      <!-- Empty state -->
      <div v-if="u1FilteredUsers.length === 0" class="u1-empty">
        <svg viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
        <span>No users match your filters.</span>
      </div>

      <!-- USER LIST -->
      <div v-else class="u1-list">
      <div
        v-for="user in u1FilteredUsers"
        :key="user.id"
        class="u1-box"
        :class="{ 'u1-box-expanded': u1ExpandedId === user.id }"
      >
        <!-- COLLAPSED ROW -->
        <div
          class="u1-box-row"
          @click="u1ToggleExpand(user.id)"
        >
          <!-- Avatar -->
          <div class="u1-av" :style="{ background: u1AvatarColor(user.id) }">
            {{ u1Initials(user) }}
            <div class="u1-online-dot" :class="{ online: user.is_online }"></div>
          </div>

          <!-- Identity -->
          <div class="u1-identity">
            <div class="u1-name">
              {{ user.first_name }} {{ user.last_name }}
              <svg class="u1-chv" :class="{ open: u1ExpandedId === user.id }" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg>
            </div>
            <div class="u1-meta">
              <span class="u1-role-badge" :class="'u1-role-' + (user.role && user.role.id)">{{ u1RoleLabel(user.role && user.role.id) }}</span>
              <span class="u1-client-ct">
                <svg viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/></svg>
                {{ user.active_clients_count || 0 }} clients
              </span>
            </div>
          </div>

          <!-- Credit Score Badge -->
          <div v-if="u1CreditScores[user.id]" class="u1-score-badge"
               :style="{ background: u1ScoreColor(u1CreditScores[user.id].score) }"
               :title="'Score: ' + u1CreditScores[user.id].score + ' — ' + u1CreditScores[user.id].rank_label">
            {{ u1CreditScores[user.id].score }}
            <span class="u1-score-label">{{ u1CreditScores[user.id].rank_label }}</span>
          </div>

          <!-- Online/Offline indicator -->
          <div class="u1-row-online-dot" :class="{ online: u1IsRecentlyActive(user) }" :title="u1IsRecentlyActive(user) ? 'Online' : 'Offline'"></div>

          <!-- Status pill -->
          <div class="u1-row-status">
            <div class="u1-status-pill" :class="user.active ? 'u1-active' : 'u1-inactive'">
              {{ user.active ? 'Active' : 'Inactive' }}
            </div>
          </div>
        </div>

        <!-- EXPANDED DETAIL -->
        <div v-if="u1ExpandedId === user.id" class="u1-expanded">

          <!-- Sub-tab bar -->
          <div class="u1-subtab-bar" @click.stop>
            <div class="u1-subtab" :class="{ on: (u1ExpandedTab[user.id] || 'info') === 'info' }" @click="$set(u1ExpandedTab, user.id, 'info')">Info</div>
            <div class="u1-subtab" :class="{ on: u1ExpandedTab[user.id] === 'shifts' }" @click="$set(u1ExpandedTab, user.id, 'shifts')">Shifts</div>
            <div class="u1-subtab" :class="{ on: u1ExpandedTab[user.id] === 'activity' }" @click="$set(u1ExpandedTab, user.id, 'activity')">Activity</div>
            <div class="u1-subtab u1-subtab-edit" :class="{ on: u1ExpandedTab[user.id] === 'edit' }" @click="u1OpenEditForm(user); $set(u1ExpandedTab, user.id, 'edit')">Edit</div>
          </div>

          <!-- ── INFO TAB ── -->
          <div v-if="(u1ExpandedTab[user.id] || 'info') === 'info'" @click.stop>
            <!-- Info grid -->
            <div class="u1-exp-grid">
              <div class="u1-exp-field">
                <div class="u1-exp-l">Email</div>
                <div class="u1-exp-v u1-mono">{{ user.email || '—' }}</div>
              </div>
              <div class="u1-exp-field">
                <div class="u1-exp-l">VoIP Ext</div>
                <div class="u1-exp-v u1-mono">{{ user.voip_user || '—' }}</div>
              </div>
              <div class="u1-exp-field">
                <div class="u1-exp-l">Team</div>
                <div class="u1-exp-v" style="display:flex;align-items:center;gap:6px;flex-wrap:wrap;">
                  <span>{{ u1UserTeamName(user) || '—' }}</span>
                  <span v-if="u1TeamChangeId === user.id" style="display:flex;align-items:center;gap:5px;">
                    <select class="u1-tf-select" style="font-size:11px;padding:3px 6px;" v-model="u1TeamChangeVal" @click.stop>
                      <option :value="null">No team</option>
                      <option v-for="t in u1TeamsList" :key="t.id" :value="t.id">{{ t.emoji || '' }} {{ t.title }}</option>
                    </select>
                    <button class="u1-team-btn u1-team-btn-primary" style="font-size:10px;padding:3px 8px;" @click.stop="u1MoveUserToTeam(user.id, u1TeamChangeVal)">Save</button>
                    <button class="u1-team-btn" style="font-size:10px;padding:3px 8px;" @click.stop="u1TeamChangeId = null">✕</button>
                  </span>
                  <button v-else class="u1-team-btn" style="font-size:10px;padding:2px 7px;" @click.stop="u1TeamChangeId = user.id; u1TeamChangeVal = user.team_id || null">Change</button>
                </div>
              </div>
              <div class="u1-exp-field">
                <div class="u1-exp-l">Last Login</div>
                <div class="u1-exp-v u1-mono">{{ u1TimeAgo(user.last_login) }}</div>
              </div>
            </div>
            <!-- KPI strip -->
            <div class="u1-qs-row">
              <div class="u1-qs">
                <div class="u1-qs-val" style="color:var(--c1-dp)">{{ user.month_deposits || 0 }}</div>
                <div class="u1-qs-lbl">Deposits</div>
              </div>
              <div class="u1-qs">
                <div class="u1-qs-val" style="color:var(--c1-ld)">{{ user.month_leads || 0 }}</div>
                <div class="u1-qs-lbl">Leads</div>
              </div>
              <div class="u1-qs">
                <div class="u1-qs-val">{{ user.active_clients_count || 0 }}</div>
                <div class="u1-qs-lbl">Clients</div>
              </div>
              <div class="u1-qs">
                <div class="u1-qs-val" style="color:var(--c1-sc)">{{ user.month_scheduled || 0 }}</div>
                <div class="u1-qs-lbl">Sched. Calls</div>
              </div>
              <div class="u1-qs">
                <div class="u1-qs-val" style="color:var(--c1-na)">{{ user.month_na_rate || '0%' }}</div>
                <div class="u1-qs-lbl">NA Rate</div>
              </div>
            </div>
            <!-- Tasks / Shifts row -->
            <div class="u1-stats-quick">
              <div class="u1-sq-item">
                <div class="u1-sq-lbl">Tasks</div>
                <div class="u1-sq-val">{{ user.tasks_done || 0 }}<span class="u1-sq-sep">/</span>{{ user.tasks_pending || 0 }}</div>
                <div class="u1-sq-sub">done / pending</div>
              </div>
              <div class="u1-sq-item">
                <div class="u1-sq-lbl">Shifts this mo</div>
                <div class="u1-sq-val">{{ user.shifts_attended || 0 }}<span class="u1-sq-sep">/</span>{{ user.shifts_total || 0 }}</div>
                <div class="u1-sq-sub">attended / total</div>
              </div>
              <div class="u1-sq-item">
                <div class="u1-sq-lbl">Shift today</div>
                <div class="u1-sq-val" style="font-size:12px">{{ user.shift_today || '—' }}</div>
              </div>
            </div>
            <!-- Credit score -->
            <div v-if="u1CreditScores[user.id]" class="u1-score-detail">
              <div class="u1-score-hdr">Performance Score</div>
              <div class="u1-score-main">
                <span class="u1-score-big" :style="{ color: u1CreditColor(u1CreditScores[user.id].score) }">{{ u1CreditScores[user.id].score }}</span>
                <span class="u1-score-rank">{{ u1CreditScores[user.id].rank_label }}</span>
              </div>
              <div v-if="u1CreditScores[user.id].breakdown" class="u1-score-breakdown">
                <div v-for="(val, key) in u1CreditScores[user.id].breakdown" :key="key" class="u1-score-row">
                  <span class="u1-score-key">{{ key.replace(/_/g,' ') }}</span>
                  <div class="u1-score-mini-bar-wrap"><div class="u1-score-mini-bar" :style="{ width: Math.min(100, val*10) + '%' }"></div></div>
                  <span class="u1-score-val">{{ val }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- ── SHIFTS TAB ── -->
          <div v-if="u1ExpandedTab[user.id] === 'shifts'" @click.stop>
            <div class="u1-exp-sec-lbl">Shift History — Last 7 Days</div>
            <div class="u1-shift-list">
              <div v-for="sh in u1ShiftHistory7()" :key="sh.date" class="u1-shift-row">
                <div class="u1-shift-date">{{ sh.date }}</div>
                <div class="u1-shift-time" :class="{ 'u1-shift-off': !sh.worked }">
                  {{ sh.worked ? (sh.start + ' – ' + sh.end) : 'Day off' }}
                </div>
                <div v-if="sh.worked" class="u1-shift-dur">{{ sh.duration }}</div>
              </div>
            </div>
          </div>

          <!-- ── ACTIVITY TAB ── -->
          <div v-if="u1ExpandedTab[user.id] === 'activity'" @click.stop>
            <div class="u1-exp-sec-lbl">Recent Activity</div>
            <div v-if="!u1ExpandedLogs[user.id] || u1ExpandedLogs[user.id].loading" style="padding:10px 0;text-align:center">
              <div class="c1-spinner" style="width:18px;height:18px;border-width:2px;display:inline-block"></div>
            </div>
            <div v-else-if="u1ExpandedLogs[user.id].data.length === 0" class="u1-att-empty">No activity logged.</div>
            <div v-else class="u1-log-list">
              <div v-for="log in u1ExpandedLogs[user.id].data" :key="log.id" class="u1-log-row">
                <div class="u1-log-badge" :class="'u1-log-' + log.type">{{ log.type }}</div>
                <div class="u1-log-body">
                  <span class="u1-log-desc">{{ log.description }}</span>
                  <span class="u1-log-time u1-mono">{{ u1TimeAgo(log.created_at) }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- ── EDIT TAB ── -->
          <div v-if="u1ExpandedTab[user.id] === 'edit' && u1EditForms[user.id]" @click.stop>
            <div class="u1-edit-form">
              <div class="u1-au-row">
                <div class="u1-au-field">
                  <label class="u1-au-lbl">First Name</label>
                  <input class="u1-au-input" v-model.trim="u1EditForms[user.id].first_name" type="text" />
                </div>
                <div class="u1-au-field">
                  <label class="u1-au-lbl">Last Name</label>
                  <input class="u1-au-input" v-model.trim="u1EditForms[user.id].last_name" type="text" />
                </div>
              </div>
              <div class="u1-au-row">
                <div class="u1-au-field">
                  <label class="u1-au-lbl">Email</label>
                  <input class="u1-au-input" v-model.trim="u1EditForms[user.id].email" type="email" />
                </div>
                <div class="u1-au-field">
                  <label class="u1-au-lbl">VoIP Ext</label>
                  <input class="u1-au-input" v-model.trim="u1EditForms[user.id].voip_user" type="text" placeholder="e.g. 201" />
                </div>
              </div>
              <div class="u1-au-row">
                <div class="u1-au-field">
                  <label class="u1-au-lbl">New Password <span class="u1-au-hint">(leave blank to keep)</span></label>
                  <input class="u1-au-input" v-model="u1EditForms[user.id].password" type="password" placeholder="New password…" />
                </div>
              </div>
              <!-- Role pills -->
              <div class="u1-au-field u1-au-field-full" style="margin-bottom:10px">
                <label class="u1-au-lbl">Role</label>
                <div class="u1-au-role-grid">
                  <div
                    v-for="r in u1RoleOptions" :key="r.id"
                    class="u1-au-role-pill"
                    :class="{ on: u1EditForms[user.id].role === r.id }"
                    :style="u1EditForms[user.id].role === r.id ? { background: r.color, borderColor: r.color, color:'#fff' } : { borderColor: r.color, color: r.color }"
                    @click="u1EditForms[user.id].role = r.id"
                  >{{ r.label }}</div>
                </div>
              </div>
              <!-- Team pills -->
              <div class="u1-au-field u1-au-field-full" style="margin-bottom:10px">
                <label class="u1-au-lbl">Team</label>
                <div class="u1-au-pill-row">
                  <div class="u1-au-pill" :class="{on: u1EditForms[user.id].team_id === null}" @click="u1EditForms[user.id].team_id = null">No team</div>
                  <div v-for="t in u1TeamsList" :key="t.id" class="u1-au-pill" :class="{on: u1EditForms[user.id].team_id === t.id}" @click="u1EditForms[user.id].team_id = t.id">{{ t.emoji }} {{ t.title }}</div>
                </div>
              </div>
              <!-- Permissions -->
              <div class="u1-au-checks" style="margin-bottom:12px">
                <label class="u1-check-lbl"><input type="checkbox" v-model="u1EditForms[user.id].active" /> Active</label>
                <label class="u1-check-lbl"><input type="checkbox" v-model="u1EditForms[user.id].stats_active" /> Statistics</label>
                <label class="u1-check-lbl"><input type="checkbox" v-model="u1EditForms[user.id].reports_active" /> Reports</label>
              </div>
              <div v-if="u1EditMsg[user.id]" :class="u1EditMsg[user.id].ok ? 'u1-au-ok' : 'u1-au-err'">{{ u1EditMsg[user.id].text }}</div>
              <button class="u1-au-btn" :disabled="u1EditSavingId === user.id" @click.stop="u1SubmitEditUser(user.id)">
                {{ u1EditSavingId === user.id ? 'Saving…' : 'Save Changes' }}
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
    </div><!-- /u1-list-wrap -->

  </div>
</template>

<script>
import VikiFace from "../../clients1.feature/VikiFace.vue";
import C1ModCalendar from '../../../components/C1ModCalendar.vue';

export default {
  name: "Users1Container",

  components: { VikiFace, C1ModCalendar },

  data() {
    return {
      c1Status: 'available',
      c1StatusSince: 0,
      c1StatusElapsed: '00:00',
      c1StatusMenuOpen: false,
      _c1StatusInterval: null,
      c1HamMenuOpen: false,
      c1ShiftMenuOpen: false,
      c1TopTab: null,
      c1ShiftElapsed: '00:00',
      c1ShiftStartTime: 0,
      c1BathroomCount: 0,
      c1CoffeeCount: 0,
      c1WeekLog: [],
      c1SlideOpen: null,
      c1PanelActiveContent: null,
      c1NavMode: 'panels',
      c1VikiMood: 'neutral',
      c1VikiSpeaking: false,
      u1Loading: false,
      u1Users: [],

      // Filters
      u1Filters: {
        role: null,
        active: null,
        team: null,
        search: ""
      },

      // Expanded accordion row
      u1ExpandedId: null,

      // Detail drawer
      u1DetailUser: null,
      u1DetailShifts: [],
      u1DetailLogs: [],
      u1DetailLoading: false,

      // Calendar (attendance)
      u1Cal: {
        year: new Date().getFullYear(),
        month: new Date().getMonth()
      },
      u1CalMonthNames: [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ],
      u1SelectedDay: null,
      u1AttLoading: false,
      u1AttendeeMap: {},

      // Add user form
      u1NewUser: {
        first_name: "", last_name: "",
        username_special: "",
        email: "",
        password: "", rePassword: "",
        role: null, team_id: null,
        voip_user: "",
        active: true, stats_active: true, reports_active: true,
        avatarColor: "#6366f1",
        avatarDataUrl: null
      },
      u1AvatarPalette: ["#6366f1","#c75450","#d4a017","#2d9d5e","#e8891c","#1144bc","#0e7490","#7c3aed"],
      u1AddLoading: false,
      u1AddError: "",
      u1AddOk: "",

      // Bulk reassign
      u1Bulk: { from_id: null, to_id: null },
      u1BulkLoading: false,
      u1BulkMsg: "",

      // Avatar palette
      u1Colors: ["#6366f1", "#c75450", "#d4a017", "#2d9d5e", "#e8891c", "#1144bc", "#e05a3a", "#827717"],

      // Time ticker
      u1TimeStr: "",
      u1TimeTick: null,

      // Credit scores & salaries
      u1CreditScores: {},
      u1Salaries: {},

      // Viki messaging
      u1VikiMessages: [],
      u1VikiUnread: false,

      // Toast
      u1Toast: null,

      // Calendar standalone props
      u1CalendarMonth: new Date().getMonth(),
      u1CalendarYear: new Date().getFullYear(),

      // Teams management
      u1TeamsList: [],
      u1TeamsLoading: false,
      u1TeamsForm: {
        show: false,
        editId: null,
        title: '',
        color: '#0e7490',
        emoji: '⚡',
        manager_id: null
      },
      u1TeamsFormSaving: false,
      u1TeamsColorPalette: ['#0e7490','#7c3aed','#e8891c','#2d9d5e','#c75450','#6366f1'],
      u1TeamChangeId: null,
      u1TeamChangeVal: null,

      // Expanded accordion sub-tabs & edit
      u1ExpandedTab: {},
      u1EditForms: {},
      u1EditSavingId: null,
      u1EditMsg: {},
      u1ExpandedLogs: {}
    };
  },

  computed: {
    c1PanelIsOpen() {
      return !!this.c1SlideOpen && this.c1SlideOpen !== 'menu';
    },
    c1PanelAtContent() {
      return this.c1PanelIsOpen && this.c1SlideOpen !== 'nav';
    },
    c1ActivePanelLabel() {
      if (!this.c1PanelIsOpen || this.c1SlideOpen === 'nav') return 'Panels';
      const labels = { filters: 'Filters', charts: 'Charts', calendar: 'Calendar', viki: 'Viki', add: 'Add User' };
      return labels[this.c1PanelActiveContent] || 'Panels';
    },

    u1AuthUser() {
      return (this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.user) || {};
    },
    u1CurrentInitials() {
      const u = this.u1AuthUser;
      return ((u.first_name || "")[0] || "?").toUpperCase() +
             ((u.last_name || "")[0] || "").toUpperCase();
    },
    u1FilteredUsers() {
      return this.u1Users.filter(u => {
        const roleId = u.role && u.role.id;

        // Role filter
        if (this.u1Filters.role !== null && roleId !== this.u1Filters.role) return false;

        // Active filter
        if (this.u1Filters.active !== null && !!u.active !== this.u1Filters.active) return false;

        // Team filter — support both numeric team_id (from teams API) and legacy string team name
        if (this.u1Filters.team !== null) {
          const matchById = typeof this.u1Filters.team === 'number' && u.team_id === this.u1Filters.team;
          const matchByName = typeof this.u1Filters.team === 'string' && u.team === this.u1Filters.team;
          if (!matchById && !matchByName) return false;
        }

        // Search filter
        if (this.u1Filters.search) {
          const q = this.u1Filters.search.toLowerCase();
          const name = ((u.first_name || "") + " " + (u.last_name || "")).toLowerCase();
          const email = (u.email || "").toLowerCase();
          if (!name.includes(q) && !email.includes(q)) return false;
        }

        return true;
      });
    },

    u1Teams() {
      const teams = new Set();
      this.u1Users.forEach(u => { if (u.team) teams.add(u.team); });
      return Array.from(teams).sort();
    },

    u1Agents() {
      return this.u1Users.filter(u => {
        const roleId = u.role && u.role.id;
        return roleId === 7 && u.active;
      });
    },

    u1OnlineCount() {
      return this.u1Users.filter(u => u.is_online).length;
    },

    u1ActiveCount() {
      return this.u1Users.filter(u => u.active).length;
    },

    // Charts: deposits per agent (top 8)
    u1DepositBars() {
      return this.u1ChartBars("month_deposits");
    },

    u1LeadBars() {
      return this.u1ChartBars("month_leads");
    },

    u1LoadBars() {
      const agents = this.u1Users
        .filter(u => u.role && u.role.id === 7 && u.active)
        .sort((a, b) => (b.active_clients_count || 0) - (a.active_clients_count || 0))
        .slice(0, 8);
      const max = Math.max(...agents.map(u => u.active_clients_count || 0), 1);
      return agents.map(u => {
        const val = u.active_clients_count || 0;
        const pct = Math.round((val / max) * 100);
        // Color by load: green <30, orange 30-60, red >60
        const color = val < 30 ? "var(--c1-ac)" : val < 60 ? "var(--c1-sc)" : "var(--c1-na)";
        return {
          label: ((u.first_name || "")[0] || "") + ". " + (u.last_name || ""),
          val,
          pct,
          color
        };
      });
    },

    u1RoleOptions() {
      return [
        { id: 7,  label: "Sales Rep",          color: "#2d9d5e" },
        { id: 4,  label: "Sales Manager",       color: "#0e7490" },
        { id: 6,  label: "Team Leader",         color: "#1144bc" },
        { id: 5,  label: "Chat Agent",          color: "#7c3aed" },
        { id: 3,  label: "Operations Manager",  color: "#c75450" },
        { id: 13, label: "Affiliation Manager", color: "#e8891c" },
        { id: 16, label: "Marketing Manager",   color: "#d4a017" },
        { id: 9,  label: "Content Writer",      color: "#6366f1" },
        { id: 8,  label: "Tech Support",        color: "#64748b" },
        { id: 10, label: "Office Manager",      color: "#94a3b8" },
        { id: 12, label: "System Tech Support", color: "#475569" },
        { id: 1,  label: "Administrator",       color: "#dc2626" }
      ];
    },

    u1AuInitials() {
      const f = (this.u1NewUser.first_name || "").trim();
      const l = (this.u1NewUser.last_name  || "").trim();
      if (!f && !l) return "?";
      return ((f[0] || "") + (l[0] || "")).toUpperCase();
    },

    u1CalGrid() {
      const { year, month } = this.u1Cal;
      const firstDay = new Date(year, month, 1);
      // Monday-based week (0=Mon ... 6=Sun)
      const startDow = (firstDay.getDay() + 6) % 7;
      const cursor = new Date(year, month, 1 - startDow);
      const todayStr = this.u1IsoDate(new Date());
      const weeks = [];
      for (let w = 0; w < 6; w++) {
        const week = [];
        for (let d = 0; d < 7; d++) {
          const dateStr = this.u1IsoDate(cursor);
          week.push({
            date: dateStr,
            day: cursor.getDate(),
            inMonth: cursor.getMonth() === month,
            today: dateStr === todayStr
          });
          cursor.setDate(cursor.getDate() + 1);
        }
        weeks.push(week);
        if (w >= 3 && cursor.getMonth() !== month) break;
      }
      return weeks;
    },

    u1AttendeeData() {
      return this.u1SelectedDay ? (this.u1AttendeeMap[this.u1SelectedDay] || []) : [];
    },

    u1AttendeesFinal() {
      return this.u1AttendeeData;
    },
    c1CurrentPageLabel() {
      const map = {
        '/clients1':'Clients', '/tasks1':'Tasks', '/stats1':'Statistics',
        '/chat1':'Chat', '/communications1':'Communications', '/affiliation1':'Affiliation',
        '/finance1':'Finance', '/shifts1':'Shifts', '/games1':'Games',
        '/users1':'Users', '/brokers1':'Brokers', '/security1':'Security',
        '/quiz1':'Quiz', '/instruction1':'Instructions', '/settings1':'Settings', '/profile1':'My Profile',
      };
      return map[this.$route.path] || 'Menu';
    },
    c1UserInitials() {
      const u = this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.user;
      if (!u) return "?";
      return ((u.first_name || "")[0] || "").toUpperCase() + ((u.last_name || "")[0] || "").toUpperCase();
    },
    c1UserFullName() {
      const u = this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.user;
      if (!u) return "User";
      return ((u.first_name || "") + " " + (u.last_name || "")).trim() || "User";
    },
    c1RoleLabel() {
      const u = this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.user;
      const map = { 1:"Admin",2:"Team Leader",3:"Manager",4:"Senior Agent",5:"Agent",6:"Junior Agent",12:"Super Admin" };
      return map[u && u.role] || "User";
    },
    c1TzUK() { return this.c1TzTime("Europe/London"); },
    c1TzIL() { return this.c1TzTime("Asia/Jerusalem"); },
    c1TzCB() { return this.c1TzTime("America/Cayman"); },

    u1TeamMemberCountMap() {
      const map = {};
      this.u1Users.forEach(u => {
        if (u.team_id) {
          map[u.team_id] = (map[u.team_id] || 0) + 1;
        }
      });
      return map;
    },
  },

  watch: {
    c1SlideOpen(val) {
      if (val && val !== 'nav' && val !== 'menu') {
        this.c1PanelActiveContent = val;
      }
    },
    u1AttendeesFinal(v) {
      // reactive alias for template
    },
    u1ExpandedId(newId) {
      if (newId && !this.u1ExpandedLogs[newId]) {
        this.$set(this.u1ExpandedLogs, newId, { loading: true, data: [] });
        this.u1FetchActivityLogs(newId).then(logs => {
          this.$set(this.u1ExpandedLogs, newId, { loading: false, data: logs });
        });
      }
    }
  },

  created() {
    if (sessionStorage.getItem('c1keepNav')) { sessionStorage.removeItem('c1keepNav'); this.c1SlideOpen = 'nav'; this.c1NavMode = 'panels'; }
    sessionStorage.removeItem('c1openPanel');
    // Time ticker
    const tick = () => {
      const d = new Date();
      this.u1TimeStr =
        String(d.getHours()).padStart(2, "0") + ":" +
        String(d.getMinutes()).padStart(2, "0") + ":" +
        String(d.getSeconds()).padStart(2, "0");
    };
    tick();
    this.u1TimeTick = setInterval(tick, 1000);
    this.u1FetchUsers();
    this.u1FetchTeams();

    // Load credit scores for all agents
    this.u1LoadCreditScores();
  },

  beforeDestroy() {
    if (this._c1StatusInterval) clearInterval(this._c1StatusInterval);
    if (this.u1TimeTick) clearInterval(this.u1TimeTick);
  },

  mounted() {
    const savedStatus = localStorage.getItem('c1_status');
    const savedSince  = localStorage.getItem('c1_status_since');
    const today = new Date().toISOString().slice(0, 10);
    const savedShiftDay = localStorage.getItem('c1_shift_day');
    if (savedShiftDay !== today) {
      this.c1ShiftStartTime = Date.now();
      this.c1BathroomCount = 0;
      this.c1CoffeeCount = 0;
      localStorage.setItem('c1_status', 'shift');
      localStorage.setItem('c1_status_since', String(Date.now()));
      localStorage.setItem('c1_shift_start', String(Date.now()));
      localStorage.setItem('c1_shift_day', today);
      localStorage.setItem('c1_bathroom_count', '0');
      localStorage.setItem('c1_coffee_count', '0');
    } else {
      if (savedStatus) this.c1Status = savedStatus;
      this.c1ShiftStartTime = parseInt(localStorage.getItem('c1_shift_start') || String(Date.now()), 10);
      this.c1BathroomCount = parseInt(localStorage.getItem('c1_bathroom_count') || '0', 10);
      this.c1CoffeeCount   = parseInt(localStorage.getItem('c1_coffee_count') || '0', 10);
    }
    this.c1StatusSince = savedSince ? parseInt(savedSince, 10) : Date.now();
    this._c1StatusInterval = setInterval(this.c1TickStatus, 1000);
    document.documentElement.style.setProperty('--gnm-sw', '0px');
    this.u1LoadCreditScores();
  },

  methods: {
    c1SetStatus(s) {
      if (s === 'bathroom') this.c1BathroomCount++;
      if (s === 'coffee')   this.c1CoffeeCount++;
      this.c1Status = s;
      this.c1StatusSince = Date.now();
      this.c1StatusElapsed = '00:00';
      this.c1ShiftMenuOpen = false;
      localStorage.setItem('c1_status', s);
      localStorage.setItem('c1_status_since', String(this.c1StatusSince));
      if (s === 'bathroom') localStorage.setItem('c1_bathroom_count', String(this.c1BathroomCount));
      if (s === 'coffee')   localStorage.setItem('c1_coffee_count',   String(this.c1CoffeeCount));
      if (s === 'end') this.c1SaveTodayToLog();
    },
    c1TickStatus() {
      const fmtSec = (sec) => {
        const h = Math.floor(sec / 3600), m = Math.floor((sec % 3600) / 60), s2 = sec % 60;
        return h > 0
          ? String(h).padStart(2,'0') + ':' + String(m).padStart(2,'0') + ':' + String(s2).padStart(2,'0')
          : String(m).padStart(2,'0') + ':' + String(s2).padStart(2,'0');
      };
      this.c1StatusElapsed = fmtSec(Math.floor((Date.now() - this.c1StatusSince) / 1000));
      this.c1ShiftElapsed  = fmtSec(Math.floor((Date.now() - this.c1ShiftStartTime) / 1000));
    },
    c1SaveTodayToLog() {
      try {
        const today = new Date().toISOString().slice(0, 10);
        const workedMin = Math.floor((Date.now() - this.c1ShiftStartTime) / 60000);
        const log = JSON.parse(localStorage.getItem('c1_week_log') || '[]').filter(r => r.date !== today);
        log.unshift({ date: today, workedMin: Math.max(0, workedMin), bathroom: this.c1BathroomCount, coffee: this.c1CoffeeCount });
        localStorage.setItem('c1_week_log', JSON.stringify(log.slice(0, 14)));
        this.c1WeekLog = log.slice(0, 14);
      } catch(e) {}
    },
    c1TzTime(tz) {
      try {
        return new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", timeZone: tz });
      } catch(e) { return "--:--"; }
    },
    c1Logout() {
      this.$store.dispatch('user/logOut');
    },
    // ---- Data fetching ----

    async u1FetchUsers() {
      this.u1Loading = true;
      try {
        const token = (this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.token) ||
                      localStorage.getItem("user-token");
        const res = await fetch("/api/users/table", {
          headers: { Authorization: "Bearer " + token }
        });
        const json = await res.json();
        const raw = (json && json.data) || json || [];
        this.u1Users = raw
          .sort((a, b) => b.id - a.id)
          .map(u => ({
            ...u,
            role: u.role
              ? { id: u.role.id || u.role.role_id, name: u.role.role_en || u.role.name }
              : null,
            active_clients_count: u.active_clients_count || 0,
            month_deposits: u.month_deposits || 0,
            month_leads: u.month_leads || 0,
            month_scheduled: u.month_scheduled || 0,
            month_na_rate: u.month_na_rate || "0%",
            is_online: !!u.is_online,
            active: u.active !== undefined ? !!u.active : true,
            team: u.team || null,
            shift_today: u.shift_today || null,
            last_login: u.last_login || null,
            seniority: u.seniority || null
          }));
      } catch (e) {
        console.error("[Users1] Failed to fetch users:", e);
      } finally {
        this.u1Loading = false;
      }
    },

    async u1FetchActivityLogs(userId) {
      try {
        const token = (this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.token) ||
                      localStorage.getItem("user-token");
        const res = await fetch("/api/users/activity_logs?user_id=" + userId, {
          headers: { Authorization: "Bearer " + token }
        });
        const json = await res.json();
        const logs = (json && json.data) || json || [];
        // Return last 5
        return logs.slice(0, 5).map(l => ({
          id: l.id || Math.random(),
          type: l.type || l.action || "act",
          description: l.description || l.message || "",
          created_at: l.created_at || null
        }));
      } catch (e) {
        console.error("[Users1] Failed to fetch activity logs:", e);
        return [];
      }
    },

    // ---- Slide open/close ----

    c1OpenSlide(name) {
      this.c1SlideOpen = this.c1SlideOpen === name ? null : name;
    },
    c1PanelBtnClick() {
      this.c1SlideOpen = this.c1PanelIsOpen ? null : 'nav';
    },
    c1SelectPanel(panel) {
      this.c1SlideOpen = panel;
    },
    c1FilterPanelClick(e) {
      // Panel stays open after selecting a filter option — user uses back (←) or X to navigate/close
    },

    // ---- User list ----

    u1ToggleExpand(id) {
      this.u1ExpandedId = this.u1ExpandedId === id ? null : id;
      // Reset to info tab on collapse
      if (this.u1ExpandedId !== id) {
        this.$set(this.u1ExpandedTab, id, 'info');
      }
    },

    u1ShiftHistory7() {
      const today = new Date();
      const shifts = [];
      for (let i = 6; i >= 0; i--) {
        const d = new Date(today);
        d.setDate(today.getDate() - i);
        const dateStr = this.u1IsoDate(d);
        const worked = d.getDay() !== 0 && d.getDay() !== 6;
        shifts.push({ date: dateStr, worked, start: worked ? '09:00' : null, end: worked ? '18:00' : null, duration: worked ? '9h' : null });
      }
      return shifts;
    },

    u1OpenEditForm(user) {
      this.$set(this.u1EditForms, user.id, {
        first_name: user.first_name || '',
        last_name: user.last_name || '',
        email: user.email || '',
        voip_user: user.voip_user || '',
        role: user.role ? user.role.id : null,
        team_id: user.team_id || null,
        active: !!user.active,
        stats_active: !!user.stats_active,
        reports_active: !!user.reports_active,
        password: ''
      });
    },

    async u1SubmitEditUser(userId) {
      const form = this.u1EditForms[userId];
      if (!form) return;
      this.u1EditSavingId = userId;
      this.$set(this.u1EditMsg, userId, null);
      try {
        const token = (this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.token) ||
                      localStorage.getItem('user-token');
        const payload = {
          id: userId,
          first_name: form.first_name,
          last_name: form.last_name,
          email: form.email,
          role: form.role,
          team_id: form.team_id,
          voip_user: form.voip_user,
          active: form.active ? 1 : 0,
          stats_active: form.stats_active ? 1 : 0,
          reports_active: form.reports_active ? 1 : 0
        };
        if (form.password && form.password.length >= 3) {
          payload.password = form.password;
        }
        const res = await fetch('/api/admin/users/' + userId, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
          body: JSON.stringify(payload)
        });
        if (res.ok) {
          this.$set(this.u1EditMsg, userId, { ok: true, text: 'Saved successfully.' });
          await this.u1FetchUsers();
        } else {
          const j = await res.json().catch(() => ({}));
          this.$set(this.u1EditMsg, userId, { ok: false, text: j.error || 'Save failed.' });
        }
      } catch(e) {
        this.$set(this.u1EditMsg, userId, { ok: false, text: 'Network error.' });
      } finally {
        this.u1EditSavingId = null;
      }
    },

    async u1OpenDetail(user) {
      this.u1DetailUser = user;
      this.u1DetailLoading = true;
      this.u1DetailShifts = [];
      this.u1DetailLogs = [];

      try {
        // Build mock shift history for last 7 days
        // Real data would come from API — use activity_logs as proxy
        const logs = await this.u1FetchActivityLogs(user.id);
        this.u1DetailLogs = logs;

        // Shift history: generate 7-day skeleton from available data
        // In production this would be /api/users/{id}/shifts?days=7
        const today = new Date();
        const shifts = [];
        for (let i = 6; i >= 0; i--) {
          const d = new Date(today);
          d.setDate(today.getDate() - i);
          const dateStr = this.u1IsoDate(d);
          // Placeholder until real shift API exists
          const worked = d.getDay() !== 0 && d.getDay() !== 6;
          shifts.push({
            date: dateStr,
            worked,
            start: worked ? "09:00" : null,
            end: worked ? "18:00" : null,
            duration: worked ? "9h" : null
          });
        }
        this.u1DetailShifts = shifts;
      } finally {
        this.u1DetailLoading = false;
      }
    },

    // ---- Filters ----

    u1SetRoleFilter(role) {
      this.u1Filters.role = role;
    },

    u1CountByRole(roleId) {
      return this.u1Users.filter(u => u.role && u.role.id === roleId).length;
    },

    // ---- Add user ----

    u1AuPickImage(e) {
      const file = e.target.files[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = ev => { this.u1NewUser.avatarDataUrl = ev.target.result; };
      reader.readAsDataURL(file);
      this._u1AuImageFile = file;
    },

    async u1SubmitNewUser() {
      this.u1AddError = "";
      this.u1AddOk = "";
      const f = this.u1NewUser;
      if (!f.first_name || !f.last_name || !f.email || !f.username_special || !f.role || !f.team_id || !f.password) {
        this.u1AddError = "All required fields must be filled.";
        return;
      }
      if (f.password !== f.rePassword) {
        this.u1AddError = "Passwords do not match.";
        return;
      }
      if (f.password.length < 6) {
        this.u1AddError = "Password must be at least 6 characters.";
        return;
      }
      this.u1AddLoading = true;
      try {
        const token = (this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.token) ||
                      localStorage.getItem("user-token");

        // Build avatar: canvas-generate initials if no photo
        let profileImg = null;
        if (f.avatarDataUrl) {
          profileImg = f.avatarDataUrl;
        } else {
          const canvas = document.createElement("canvas");
          canvas.width = 120; canvas.height = 120;
          const ctx = canvas.getContext("2d");
          ctx.fillStyle = f.avatarColor;
          ctx.beginPath(); ctx.arc(60, 60, 60, 0, Math.PI * 2); ctx.fill();
          ctx.fillStyle = "#fff";
          ctx.font = "bold 44px sans-serif";
          ctx.textAlign = "center"; ctx.textBaseline = "middle";
          const initials = ((f.first_name[0] || "") + (f.last_name[0] || "")).toUpperCase();
          ctx.fillText(initials, 60, 62);
          profileImg = canvas.toDataURL("image/png");
        }

        const payload = {
          first_name:       f.first_name,
          last_name:        f.last_name,
          email:            f.email,
          password:         f.password,
          username_special: f.username_special,
          role:             f.role,
          team_id:          f.team_id,
          voip_user:        f.voip_user || null,
          active:           f.active ? 1 : 0,
          stats_active:     f.stats_active ? 1 : 0,
          reports_active:   f.reports_active ? 1 : 0,
          profile_img:      profileImg
        };
        const res = await fetch("/api/admin/user", {
          method: "POST",
          headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
          body: JSON.stringify(payload)
        });
        if (res.status === 507) { this.u1AddError = "Email already in use."; return; }
        if (res.status === 508) { this.u1AddError = "Username already taken."; return; }
        if (!res.ok) throw new Error("Server error " + res.status);
        this.u1AddOk = f.first_name + " " + f.last_name + " created!";
        this.u1NewUser = {
          first_name: "", last_name: "", username_special: "", email: "",
          password: "", rePassword: "", role: null, team_id: null,
          voip_user: "", active: true, stats_active: true, reports_active: true,
          avatarColor: "#6366f1", avatarDataUrl: null
        };
        this._u1AuImageFile = null;
        setTimeout(() => { this.c1TopTab = null; this.u1AddOk = ""; }, 2000);
        await this.u1FetchUsers();
      } catch (e) {
        this.u1AddError = e.message || "Failed to create user.";
      } finally {
        this.u1AddLoading = false;
      }
    },

    // ---- Bulk reassign ----

    async u1SubmitBulkReassign() {
      this.u1BulkMsg = "";
      if (!this.u1Bulk.from_id || !this.u1Bulk.to_id) return;
      this.u1BulkLoading = true;
      try {
        const token = (this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.token) ||
                      localStorage.getItem("user-token");
        const res = await fetch("/api/users/temp_assignment", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token
          },
          body: JSON.stringify({ from_user_id: this.u1Bulk.from_id, to_user_id: this.u1Bulk.to_id })
        });
        if (!res.ok) throw new Error("Server error " + res.status);
        this.u1BulkMsg = "Assignment updated successfully.";
        this.u1Bulk = { from_id: null, to_id: null };
        await this.u1FetchUsers();
      } catch (e) {
        this.u1BulkMsg = "Error: " + (e.message || "Reassign failed.");
      } finally {
        this.u1BulkLoading = false;
      }
    },

    // ---- Attendance calendar ----

    u1CalPrev() {
      if (this.u1Cal.month === 0) { this.u1Cal.month = 11; this.u1Cal.year--; }
      else this.u1Cal.month--;
    },

    u1CalNext() {
      if (this.u1Cal.month === 11) { this.u1Cal.month = 0; this.u1Cal.year++; }
      else this.u1Cal.month++;
    },

    async u1SelectDay(day) {
      if (!day.inMonth) return;
      this.u1SelectedDay = day.date;
      if (this.u1AttendeeMap[day.date]) return; // cached
      this.u1AttLoading = true;
      try {
        const token = (this.$store.state.user && this.$store.state.user.auth && this.$store.state.user.auth.token) ||
                      localStorage.getItem("user-token");
        // Backend route: shifts/all_users_shifts_for_today/{day} — pass YYYY-MM-DD date string
        const res = await fetch("/api/shifts/all_users_shifts_for_today/" + day.date, {
          headers: { Authorization: "Bearer " + token }
        });
        const json = await res.json();
        this.$set(this.u1AttendeeMap, day.date, Array.isArray(json) ? json : (json && json.data) || []);
      } catch (e) {
        this.$set(this.u1AttendeeMap, day.date, []);
      } finally {
        this.u1AttLoading = false;
      }
    },

    // ---- Helpers ----

    u1Initials(user) {
      return ((user.first_name || "")[0] || "?").toUpperCase() +
             ((user.last_name || "")[0] || "").toUpperCase();
    },

    u1AvatarColor(id) {
      return this.u1Colors[(id || 0) % this.u1Colors.length];
    },

    u1RoleLabel(roleId) {
      const map = { 1: "Admin", 4: "Manager", 5: "Chat Agent", 6: "Team Leader", 7: "Sales Agent" };
      return map[roleId] || "User";
    },

    u1TimeAgo(ts) {
      if (!ts) return "—";
      const diff = Date.now() - new Date(ts).getTime();
      const m = Math.floor(diff / 60000);
      if (m < 1) return "just now";
      if (m < 60) return m + "m ago";
      const h = Math.floor(m / 60);
      if (h < 24) return h + "h ago";
      const d = Math.floor(h / 24);
      if (d < 30) return d + "d ago";
      return Math.floor(d / 30) + "mo ago";
    },


    u1IsoDate(d) {
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return y + "-" + m + "-" + day;
    },

    u1ChartBars(field) {
      const agents = this.u1Users
        .filter(u => u.role && u.role.id === 7 && u.active)
        .sort((a, b) => (b[field] || 0) - (a[field] || 0))
        .slice(0, 8);
      const max = Math.max(...agents.map(u => u[field] || 0), 1);
      return agents.map(u => ({
        label: ((u.first_name || "")[0] || "") + ". " + (u.last_name || ""),
        val: u[field] || 0,
        pct: Math.round(((u[field] || 0) / max) * 100)
      }));
    },

    u1CreditColor: function(score) {
      if (score >= 8) return '#10b981';
      if (score >= 6) return '#6366f1';
      if (score >= 4) return '#f59e0b';
      return '#ef4444';
    },

    u1AuthHeaders: function() {
      return { Authorization: 'Bearer ' + localStorage.getItem('user-token') };
    },

    u1CreditColorNum(score) {
      if (score > 70) return '#10b981';
      if (score >= 40) return '#f59e0b';
      return '#ef4444';
    },

    u1IsRecentlyActive(user) {
      // Online if is_online flag is set, or last_login within 30 minutes
      if (user.is_online) return true;
      if (!user.last_login) return false;
      const diff = Date.now() - new Date(user.last_login).getTime();
      return diff < 30 * 60 * 1000; // 30 minutes
    },

    u1ShowToast(msg, color) {
      if (this._u1ToastTimer) clearTimeout(this._u1ToastTimer);
      this.u1Toast = { msg, color: color || '#6366f1' };
      this._u1ToastTimer = setTimeout(() => { this.u1Toast = null; }, 3000);
    },

    async u1LoadCreditScores() {
      try {
        const token = localStorage.getItem('user-token');
        const res = await fetch('/api/admin/agent/credit-scores/all', {
          headers: { Authorization: 'Bearer ' + token }
        });
        const data = await res.json();
        const agents = data && data.agents ? data.agents : [];
        const map = {};
        agents.forEach(a => { map[a.agent_id] = a; });
        this.u1CreditScores = map;
      } catch(e) {}
    },

    u1ScoreColor(score) {
      if (!score) return 'rgba(255,255,255,.2)';
      if (score >= 8) return 'rgba(0,182,122,.25)';
      if (score >= 5) return 'rgba(245,158,11,.25)';
      return 'rgba(239,68,68,.25)';
    },

    // ---- Teams management ----

    async u1FetchTeams() {
      this.u1TeamsLoading = true;
      try {
        const token = localStorage.getItem('user-token');
        const res = await fetch('/api/admin/teams', {
          headers: { Authorization: 'Bearer ' + token }
        });
        const json = await res.json();
        this.u1TeamsList = (json && json.teams) || json || [];
      } catch(e) {
        console.error('[Users1] Failed to fetch teams:', e);
      } finally {
        this.u1TeamsLoading = false;
      }
    },

    async u1SaveTeam() {
      if (!this.u1TeamsForm.title) return;
      this.u1TeamsFormSaving = true;
      try {
        const token = localStorage.getItem('user-token');
        const payload = {
          title: this.u1TeamsForm.title,
          color: this.u1TeamsForm.color,
          emoji: this.u1TeamsForm.emoji,
          manager_id: this.u1TeamsForm.manager_id
        };
        let res;
        if (this.u1TeamsForm.editId) {
          res = await fetch('/api/admin/teams/' + this.u1TeamsForm.editId, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
            body: JSON.stringify(payload)
          });
        } else {
          res = await fetch('/api/admin/teams', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
            body: JSON.stringify(payload)
          });
        }
        if (!res.ok) throw new Error('Server error ' + res.status);
        this.u1TeamsForm.show = false;
        this.u1ShowToast(this.u1TeamsForm.editId ? 'Team updated.' : 'Team created.', '#10b981');
        await this.u1FetchTeams();
        await this.u1FetchUsers();
      } catch(e) {
        this.u1ShowToast('Failed to save team.', '#ef4444');
      } finally {
        this.u1TeamsFormSaving = false;
      }
    },

    async u1DeleteTeam(id) {
      try {
        const token = localStorage.getItem('user-token');
        const res = await fetch('/api/admin/teams/' + id, {
          method: 'DELETE',
          headers: { Authorization: 'Bearer ' + token }
        });
        if (res.status === 409) {
          this.u1ShowToast('Team has members, move them first.', '#ef4444');
          return;
        }
        if (!res.ok) throw new Error('Server error ' + res.status);
        this.u1ShowToast('Team deleted.', '#10b981');
        await this.u1FetchTeams();
      } catch(e) {
        this.u1ShowToast('Failed to delete team.', '#ef4444');
      }
    },

    u1FilterByTeam(teamId) {
      this.u1Filters.team = teamId;
      this.c1TopTab = null;
    },

    async u1MoveUserToTeam(userId, teamId) {
      try {
        const token = localStorage.getItem('user-token');
        const res = await fetch('/api/admin/user/' + userId, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
          body: JSON.stringify({ team_id: teamId })
        });
        if (!res.ok) throw new Error('Server error ' + res.status);
        this.u1TeamChangeId = null;
        this.u1TeamChangeVal = null;
        this.u1ShowToast('Team updated.', '#10b981');
        await this.u1FetchUsers();
      } catch(e) {
        this.u1ShowToast('Failed to update team.', '#ef4444');
      }
    },

    u1TeamMemberCount(teamId) {
      return this.u1TeamMemberCountMap[teamId] || 0;
    },

    u1TeamManagerName(managerId) {
      if (!managerId) return 'None';
      const u = this.u1Users.find(u => u.id === managerId);
      return u ? (u.first_name + ' ' + u.last_name) : '—';
    },

    u1UserTeamName(user) {
      if (user.team_id && this.u1TeamsList.length) {
        const t = this.u1TeamsList.find(t => t.id === user.team_id);
        if (t) return (t.emoji ? t.emoji + ' ' : '') + t.title;
      }
      return user.team || null;
    }
  }
};
</script>

<style scoped>
/* ====================================================
   Users1 — dark-variant scoped styles
   Inherits c1-main base vars from c1-design.css
   ==================================================== */

/* Hide the right-side panel — replaced by top strip */
.c1-users-page .c1-panel { display: none !important; }


/* Design tokens — scoped to c1-main wrapper */
.c1-main {
  /* ── Standard c1 design tokens (light theme) ── */
  --c1-bg:      #f4f3f0;
  --c1-surface: #ffffff;
  --c1-surface2: #f4f3f0;
  --c1-border:  #e4e3df;
  --c1-text:    #1a1a1a;
  --c1-muted:   #a09e98;
  --c1-accent:  #7c5cfc;
  --c1-accent2: #6366f1;
  --c1-dp:      #7c5cfc;
  --c1-ld:      #d4a017;
  --c1-na:      #e05a3a;
  --c1-sc:      #e8891c;
  --c1-rf:      #c75450;
  --c1-ni:      #7a7067;

  /* ── Legacy local aliases ── */
  --u1-bg:      var(--c1-bg);
  --u1-surface: var(--c1-surface);
  --u1-brd:     var(--c1-border);
  --u1-brd-l:   #eeedea;
  --u1-t1:      var(--c1-text);
  --u1-t2:      #6b6963;
  --u1-t3:      #a09e98;
  --u1-ac:      var(--c1-accent);
  --u1-ac2:     rgba(124,92,252,.1);
  --c1-card:    var(--c1-surface);
  --c1-brd:     var(--c1-border);
  --c1-brd-l:   var(--u1-brd-l);
  --c1-t1:      var(--c1-text);
  --c1-t2:      var(--u1-t2);
  --c1-t3:      var(--u1-t3);
  --c1-ac:      var(--c1-dp);
  --c1-act:     rgba(0,0,0,.05);
}

/* ---- Panels override ---- */
.c1-main .c1-panel { background: var(--u1-surface); border-bottom: 1px solid var(--u1-brd); }
.c1-main .c1-collapse-bar { background: var(--u1-surface); border-top: 1px solid var(--u1-brd); color: var(--u1-t3); }
.c1-main .c1-collapse-bar:hover { background: var(--u1-ac2); color: var(--u1-t1); }
.c1-main .c1-tib { background: var(--u1-surface); border-bottom: 1px solid var(--u1-brd); }
.c1-main .c1-tib-user { background: var(--u1-ac); }
.c1-main .c1-tib-btn:hover { background: var(--u1-ac2); }
.c1-main .c1-tib-btn.on { background: var(--u1-ac2); color: var(--u1-ac); }
.c1-main .c1-tib-btn.on svg { stroke: var(--u1-ac); }

/* Add button accent */
.u1-tib-add { color: var(--u1-ac) !important; }
.u1-tib-add svg { stroke: var(--u1-ac) !important; }

/* ---- Filter chips ---- */
.c1-main .c1-fp-lbl { color: var(--u1-t3); font-size: 9px; font-weight: 700; text-transform: uppercase; letter-spacing: .6px; margin-bottom: 6px; }
.c1-main .c1-fp-opt { background: rgba(0,0,0,.04); border: 1px solid var(--u1-brd); color: var(--u1-t2); border-radius: 6px; padding: 4px 10px; font-size: 11px; font-weight: 600; cursor: pointer; transition: all .12s; display: inline-flex; align-items: center; gap: 5px; }
.c1-main .c1-fp-opt:hover { background: var(--u1-ac2); border-color: var(--u1-ac); color: var(--u1-t1); }
.c1-main .c1-fp-opt.on { background: var(--u1-ac2); border-color: var(--u1-ac); color: var(--u1-ac); }
.c1-main .c1-fp-opts { display: flex; flex-wrap: wrap; gap: 6px; }
.c1-main .c1-fc { font-size: 9px; opacity: .7; }
.c1-main .c1-fp-group { min-width: 160px; flex: 1; }
.c1-main .c1-fp-full { width: 100%; flex-basis: 100%; }

/* Role chip colours */
.u1-main .u1-role-admin.on { color: #ff6b6b; border-color: #ff6b6b; background: rgba(255,107,107,.12); }
.u1-main .u1-role-manager.on { color: var(--c1-sc); border-color: var(--c1-sc); background: rgba(232,137,28,.12); }
.u1-main .u1-role-agent.on { color: var(--u1-ac); border-color: var(--u1-ac); background: var(--u1-ac2); }
.u1-main .u1-status-active.on { color: var(--c1-ac); border-color: var(--c1-ac); background: rgba(45,157,94,.12); }
.u1-main .u1-status-inactive.on { color: var(--u1-t3); border-color: var(--u1-t3); background: rgba(90,90,122,.12); }

/* ---- Search ---- */
.c1-main .c1-fp-search { display: flex; align-items: center; background: rgba(255,255,255,.04); border: 1px solid var(--u1-brd); border-radius: 8px; overflow: hidden; }
.c1-main .c1-fp-sico { width: 14px; height: 14px; stroke: var(--u1-t3); fill: none; stroke-width: 2; flex-shrink: 0; margin: 0 8px; }
.c1-main .c1-fp-sinput { flex: 1; background: none; border: none; outline: none; color: var(--u1-t1); font-size: 12px; padding: 8px 0; }
.c1-main .c1-fp-sinput::placeholder { color: var(--u1-t3); }
.c1-main .c1-fp-sclear { width: 28px; height: 28px; display: grid; place-items: center; cursor: pointer; color: var(--u1-t3); }
.c1-main .c1-fp-sclear svg { width: 12px; height: 12px; stroke: currentColor; fill: none; stroke-width: 2; }

/* ---- KPI row ---- */
.c1-main .c1-kpi-row { display: flex; gap: 10px; flex-wrap: wrap; width: 100%; }
.c1-main .c1-kpi { flex: 1; min-width: 70px; background: rgba(255,255,255,.04); border: 1px solid var(--u1-brd); border-radius: 10px; padding: 10px 12px; }
.c1-main .c1-kpi-lbl { font-size: 9px; font-weight: 700; text-transform: uppercase; letter-spacing: .5px; color: var(--u1-t3); margin-bottom: 4px; }
.c1-main .c1-kpi-val { font-size: 22px; font-weight: 800; color: var(--u1-t1); letter-spacing: -.5px; line-height: 1; }
.c1-main .c1-co-lbl { font-size: 9px; font-weight: 700; text-transform: uppercase; letter-spacing: .7px; color: var(--u1-t3); }

/* ---- Bar charts ---- */
.c1-main .c1-vbar-chart { display: flex; flex-direction: column; gap: 6px; width: 100%; }
.c1-main .c1-vbar-row { display: flex; align-items: center; gap: 8px; }
.c1-main .c1-vbar-lbl { font-size: 10px; color: var(--u1-t2); width: 60px; flex-shrink: 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.c1-main .c1-vbar-track { flex: 1; height: 18px; background: rgba(255,255,255,.05); border-radius: 4px; overflow: hidden; }
.c1-main .c1-vbar-fill { height: 100%; border-radius: 4px; display: flex; align-items: center; min-width: 18px; transition: width .4s ease; }
.c1-main .c1-vbar-val { font-size: 9px; font-weight: 700; color: rgba(255,255,255,.8); padding: 0 6px; white-space: nowrap; }
.u1-bar-dp { background: var(--c1-dp); }
.u1-bar-ld { background: var(--c1-ld); }

/* ---- Calendar ---- */
.u1-cal-head { display: flex; align-items: center; justify-content: space-between; margin-bottom: 10px; width: 100%; }
.u1-cal-title { font-size: 13px; font-weight: 700; color: var(--u1-t1); }
.u1-cal-nav { background: rgba(255,255,255,.05); border: 1px solid var(--u1-brd); border-radius: 6px; width: 28px; height: 28px; display: grid; place-items: center; cursor: pointer; color: var(--u1-t2); transition: background .12s; }
.u1-cal-nav:hover { background: var(--u1-ac2); color: var(--u1-ac); }
.u1-cal-nav svg { width: 14px; height: 14px; stroke: currentColor; fill: none; stroke-width: 2.5; stroke-linecap: round; stroke-linejoin: round; }
.u1-cal-grid { display: grid; grid-template-columns: repeat(7, 1fr); gap: 2px; width: 100%; }
.u1-cal-dh { text-align: center; font-size: 9px; font-weight: 700; text-transform: uppercase; letter-spacing: .5px; color: var(--u1-t3); padding: 4px 0 6px; }
.u1-cal-day { display: flex; flex-direction: column; align-items: center; gap: 2px; padding: 6px 4px 5px; border-radius: 6px; cursor: pointer; transition: background .12s; }
.u1-cal-day span { font-size: 11px; font-weight: 600; color: var(--u1-t2); }
.u1-cal-day:hover { background: var(--u1-ac2); }
.u1-cal-day:hover span { color: var(--u1-ac); }
.u1-cal-oom span { color: var(--u1-t3); opacity: .4; }
.u1-cal-oom { pointer-events: none; }
.u1-cal-today span { color: var(--u1-ac) !important; font-weight: 800; }
.u1-cal-sel { background: var(--u1-ac2) !important; }
.u1-cal-sel span { color: var(--u1-ac) !important; }
.u1-cal-dot { width: 4px; height: 4px; border-radius: 50%; background: var(--u1-t3); opacity: .4; }

/* Attendance */
.u1-att-section { margin-top: 14px; width: 100%; }
.u1-att-spin { display: flex; justify-content: center; padding: 16px; }
.u1-att-empty { font-size: 11px; color: var(--u1-t3); padding: 10px 0; }
.u1-att-hint { font-size: 11px; color: var(--u1-t3); padding: 14px 0; text-align: center; }
.u1-att-list { display: flex; flex-direction: column; gap: 6px; }
.u1-att-row { display: flex; align-items: center; gap: 8px; padding: 8px 10px; background: rgba(255,255,255,.04); border: 1px solid var(--u1-brd); border-radius: 8px; }
.u1-att-name { flex: 1; font-size: 12px; font-weight: 600; color: var(--u1-t1); }
.u1-att-time { font-size: 10px; color: var(--u1-t3); font-family: 'JetBrains Mono', monospace; }

/* ---- Add panel form ---- */
.u1-form-grid { display: flex; flex-wrap: wrap; gap: 10px; width: 100%; margin-top: 8px; }
.u1-form-group { display: flex; flex-direction: column; gap: 5px; flex: 1; min-width: 140px; }
.u1-form-full { flex-basis: 100%; width: 100%; }
.u1-form-half { flex-basis: calc(50% - 5px); }
.u1-form-lbl { font-size: 9px; font-weight: 700; text-transform: uppercase; letter-spacing: .5px; color: var(--u1-t3); }
.u1-form-input { background: rgba(255,255,255,.05); border: 1px solid var(--u1-brd); border-radius: 8px; color: var(--u1-t1); font-size: 12px; padding: 8px 10px; outline: none; transition: border-color .15s; width: 100%; box-sizing: border-box; }
.u1-form-input:focus { border-color: var(--u1-ac); }
.u1-form-input::placeholder { color: var(--u1-t3); }
.u1-form-select { background: rgba(255,255,255,.05); border: 1px solid var(--u1-brd); border-radius: 8px; color: var(--u1-t1); font-size: 12px; padding: 8px 10px; outline: none; transition: border-color .15s; width: 100%; box-sizing: border-box; appearance: none; cursor: pointer; }
.u1-form-select:focus { border-color: var(--u1-ac); }
.u1-form-err { font-size: 11px; color: #ff6b6b; padding: 6px 0; }
.u1-form-ok { font-size: 11px; color: var(--c1-ac); padding: 6px 0; }
.u1-check-row { display: flex; flex-wrap: wrap; gap: 12px; }
.u1-check-lbl { display: flex; align-items: center; gap: 6px; font-size: 12px; color: var(--u1-t2); cursor: pointer; }
.u1-check-lbl input[type="checkbox"] { width: 14px; height: 14px; cursor: pointer; accent-color: var(--u1-ac); }

/* ── Add User top-strip tab + dropdown ── */
.u1-add-tab { color: var(--c1-dp) !important; font-weight: 600; }
.u1-add-tab.on { background: var(--c1-dp) !important; color: #fff !important; }
.u1-adduser-dropdown { min-width: 680px; padding: 16px 18px 18px; }
.u1-au-body { display: flex; gap: 18px; align-items: flex-start; }

/* Avatar column */
.u1-au-avatar-col { display: flex; flex-direction: column; align-items: center; gap: 8px; flex-shrink: 0; }
.u1-au-avatar-preview { width: 80px; height: 80px; border-radius: 50%; display: flex; align-items: center; justify-content: center; overflow: hidden; flex-shrink: 0; box-shadow: 0 2px 12px rgba(0,0,0,.18); }
.u1-au-avatar-img { width: 100%; height: 100%; object-fit: cover; }
.u1-au-avatar-initials { font-size: 28px; font-weight: 700; color: #fff; letter-spacing: -.5px; }
.u1-au-avatar-colors { display: flex; gap: 5px; flex-wrap: wrap; justify-content: center; max-width: 80px; }
.u1-au-color-dot { width: 16px; height: 16px; border-radius: 50%; cursor: pointer; border: 2px solid transparent; transition: transform .15s, border-color .15s; }
.u1-au-color-dot.active { transform: scale(1.25); border-color: #fff; box-shadow: 0 0 0 2px rgba(0,0,0,.25); }
.u1-au-upload-btn { display: flex; align-items: center; gap: 5px; font-size: 10px; color: var(--u1-t2); cursor: pointer; padding: 4px 8px; border: 1px solid var(--u1-brd, rgba(0,0,0,.12)); border-radius: 6px; white-space: nowrap; transition: border-color .15s; }
.u1-au-upload-btn:hover { border-color: var(--c1-dp); color: var(--c1-dp); }

/* Fields column */
.u1-au-fields-col { flex: 1; display: flex; flex-direction: column; gap: 10px; }
.u1-au-row { display: flex; gap: 10px; }
.u1-au-field { flex: 1; display: flex; flex-direction: column; gap: 4px; }
.u1-au-field-full { width: 100%; }
.u1-au-lbl { font-size: 10px; font-weight: 600; text-transform: uppercase; letter-spacing: .04em; color: var(--u1-t2); }
.u1-au-hint { font-size: 9px; text-transform: none; letter-spacing: 0; font-weight: 400; opacity: .7; }
.u1-au-input { background: rgba(255,255,255,.07); border: 1px solid var(--u1-brd,rgba(0,0,0,.12)); border-radius: 7px; color: var(--u1-t1); font-size: 12px; padding: 7px 10px; outline: none; width: 100%; box-sizing: border-box; transition: border-color .15s; }
.u1-au-input:focus { border-color: var(--c1-dp); }

/* Team pills */
.u1-au-pill-row { display: flex; gap: 6px; }
.u1-au-pill { padding: 5px 12px; border-radius: 20px; border: 1px solid var(--u1-brd,rgba(0,0,0,.12)); font-size: 11px; cursor: pointer; color: var(--u1-t2); transition: all .15s; }
.u1-au-pill.on { background: var(--c1-dp); border-color: var(--c1-dp); color: #fff; font-weight: 600; }

/* Role pills grid */
.u1-au-role-grid { display: flex; flex-wrap: wrap; gap: 6px; }
.u1-au-role-pill { padding: 4px 11px; border-radius: 20px; border: 1.5px solid; font-size: 11px; font-weight: 500; cursor: pointer; background: transparent; transition: all .15s; white-space: nowrap; }
.u1-au-role-pill:hover { opacity: .8; }

/* Checks + actions */
.u1-au-checks { display: flex; gap: 14px; flex-wrap: wrap; padding: 2px 0; }
.u1-au-err { font-size: 11px; color: #ef4444; padding: 4px 0 2px; }
.u1-au-ok  { font-size: 11px; color: #10b981; padding: 4px 0 2px; }
.u1-au-btn { display: flex; align-items: center; gap: 6px; padding: 8px 20px; background: var(--c1-dp); color: #fff; border: none; border-radius: 8px; font-size: 12px; font-weight: 600; cursor: pointer; transition: opacity .15s; margin-top: 6px; }
.u1-au-btn:disabled { opacity: .4; cursor: not-allowed; }
.u1-au-btn:not(:disabled):hover { opacity: .85; }
.u1-submit-btn { display: flex; align-items: center; justify-content: center; gap: 6px; width: 100%; padding: 11px 16px; background: var(--u1-ac); border: none; border-radius: 10px; color: #fff; font-size: 13px; font-weight: 700; cursor: pointer; transition: opacity .15s; margin-top: 6px; }
.u1-submit-btn:hover:not(:disabled) { opacity: .88; }
.u1-submit-btn:disabled { opacity: .45; cursor: not-allowed; }
.u1-submit-btn svg { width: 14px; height: 14px; stroke: currentColor; fill: none; stroke-width: 2.5; stroke-linecap: round; stroke-linejoin: round; }
.u1-submit-bulk { background: var(--c1-sc); margin-top: 10px; }
.u1-bulk-row { display: flex; align-items: flex-end; gap: 8px; width: 100%; margin-top: 8px; }
.u1-bulk-arrow { width: 24px; height: 36px; display: grid; place-items: center; flex-shrink: 0; color: var(--u1-t3); }
.u1-bulk-arrow svg { width: 16px; height: 16px; stroke: currentColor; fill: none; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }
.u1-add-panel .c1-sl-body { gap: 0; }

/* ---- User list ---- */
.u1-loading { display: flex; align-items: center; justify-content: center; gap: 10px; padding: 40px 20px; color: var(--u1-t3); font-size: 12px; }
.u1-empty { display: flex; flex-direction: column; align-items: center; gap: 10px; padding: 60px 20px; color: var(--u1-t3); font-size: 12px; }
.u1-empty svg { width: 32px; height: 32px; stroke: var(--u1-t3); fill: none; stroke-width: 1.5; stroke-linecap: round; stroke-linejoin: round; opacity: .5; }
.u1-list { display: flex; flex-direction: column; padding: 8px 0 24px; }

.u1-box { border-bottom: 1px solid var(--u1-brd); transition: background .12s; }
.u1-box:last-child { border-bottom: none; }
.u1-box-row { display: flex; align-items: center; gap: 10px; padding: 10px 14px; cursor: pointer; transition: background .12s; }
.u1-box-row:hover { background: rgba(99,102,241,.04); }
.u1-box-expanded .u1-box-row { background: rgba(99,102,241,.06); }

/* Avatar */
.u1-av { width: 36px; height: 36px; border-radius: 50%; display: grid; place-items: center; font-size: 12px; font-weight: 700; color: #fff; flex-shrink: 0; position: relative; letter-spacing: -.3px; }
.u1-av-lg { width: 52px; height: 52px; font-size: 17px; flex-shrink: 0; }
.u1-online-dot { position: absolute; bottom: 1px; right: 1px; width: 9px; height: 9px; border-radius: 50%; background: var(--u1-t3); border: 2px solid var(--u1-surface); }
.u1-online-dot.online { background: var(--c1-ac); }

/* Identity */
.u1-identity { flex: 1; min-width: 0; }
.u1-name { font-size: 13px; font-weight: 600; color: var(--u1-t1); display: flex; align-items: center; gap: 6px; margin-bottom: 3px; }
.u1-chv { width: 14px; height: 14px; transition: transform .2s; flex-shrink: 0; opacity: .5; }
.u1-chv.open { transform: rotate(180deg); opacity: 1; }
.u1-meta { display: flex; align-items: center; gap: 6px; flex-wrap: wrap; }

/* Role badge */
.u1-role-badge { display: inline-flex; align-items: center; padding: 2px 8px; border-radius: 20px; font-size: 9px; font-weight: 700; text-transform: uppercase; letter-spacing: .4px; }
.u1-role-1 { background: rgba(255,107,107,.15); color: #ff6b6b; }
.u1-role-2 { background: rgba(232,137,28,.15); color: var(--c1-sc); }
.u1-role-3 { background: var(--u1-ac2); color: var(--u1-ac); }

/* Active client count chip */
.u1-client-ct { display: inline-flex; align-items: center; gap: 4px; font-size: 10px; color: var(--u1-t3); }
.u1-client-ct svg { width: 10px; height: 10px; stroke: currentColor; fill: none; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }

/* Status pill */
.u1-row-status { flex-shrink: 0; }
.u1-status-pill { font-size: 9px; font-weight: 700; text-transform: uppercase; letter-spacing: .4px; padding: 3px 8px; border-radius: 20px; }
.u1-active { background: rgba(45,157,94,.15); color: var(--c1-ac); }
.u1-inactive { background: rgba(90,90,122,.12); color: var(--u1-t3); }

/* ---- Expanded row ---- */
.u1-expanded { padding: 10px 14px 14px 14px; border-top: 1px solid var(--u1-brd, #e4e3df); }
.u1-exp-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; margin-bottom: 10px; }
.u1-exp-field { background: rgba(255,255,255,.03); border: 1px solid var(--u1-brd); border-radius: 8px; padding: 8px 10px; }
.u1-exp-l { font-size: 9px; font-weight: 700; text-transform: uppercase; letter-spacing: .4px; color: var(--u1-t3); margin-bottom: 3px; }
.u1-exp-v { font-size: 11px; color: var(--u1-t1); font-weight: 500; word-break: break-all; }
.u1-mono { font-family: 'JetBrains Mono', monospace; }

/* Quick stats row */
.u1-qs-row { display: flex; gap: 8px; margin-bottom: 10px; }
.u1-qs { flex: 1; background: rgba(255,255,255,.03); border: 1px solid var(--u1-brd); border-radius: 8px; padding: 8px 10px; text-align: center; }
.u1-qs-val { font-size: 18px; font-weight: 800; letter-spacing: -.5px; line-height: 1; margin-bottom: 3px; color: var(--u1-t1); }
.u1-qs-lbl { font-size: 9px; color: var(--u1-t3); font-weight: 600; text-transform: uppercase; letter-spacing: .4px; }

/* Detail btn */
.u1-detail-btn { display: flex; align-items: center; justify-content: center; gap: 5px; width: 100%; padding: 9px 12px; background: rgba(99,102,241,.08); border: 1px solid rgba(99,102,241,.2); border-radius: 8px; color: var(--u1-ac); font-size: 12px; font-weight: 600; cursor: pointer; transition: background .12s; }
.u1-detail-btn:hover { background: var(--u1-ac2); }
.u1-detail-btn svg { width: 14px; height: 14px; stroke: currentColor; fill: none; stroke-width: 2.5; stroke-linecap: round; stroke-linejoin: round; }

/* ---- Detail drawer (slides from right) ---- */
.u1-drawer { position: fixed; inset: 0; z-index: 400; display: flex; justify-content: flex-end; }
.u1-drawer-inner { width: 100%; max-width: 420px; background: var(--u1-surface); border-left: 1px solid var(--u1-brd); display: flex; flex-direction: column; overflow: hidden; box-shadow: -8px 0 32px rgba(0,0,0,.4); }
.u1-drawer-hdr { display: flex; align-items: flex-start; gap: 12px; padding: 16px; border-bottom: 1px solid var(--u1-brd); flex-shrink: 0; }
.u1-drawer-meta { flex: 1; min-width: 0; padding-top: 4px; }
.u1-drawer-name { font-size: 16px; font-weight: 700; color: var(--u1-t1); letter-spacing: -.3px; margin-bottom: 3px; }
.u1-drawer-sub { font-size: 11px; color: var(--u1-t3); margin-top: 3px; display: flex; align-items: center; gap: 6px; flex-wrap: wrap; }
.u1-sen-badge { display: inline-flex; align-items: center; padding: 2px 8px; border-radius: 20px; font-size: 9px; font-weight: 700; background: rgba(255,255,255,.06); color: var(--u1-t2); text-transform: uppercase; letter-spacing: .4px; }
.u1-drawer-close { width: 30px; height: 30px; border-radius: 50%; background: rgba(255,255,255,.06); border: none; display: grid; place-items: center; cursor: pointer; color: var(--u1-t2); flex-shrink: 0; transition: background .12s; }
.u1-drawer-close:hover { background: rgba(255,107,107,.15); color: #ff6b6b; }
.u1-drawer-close svg { width: 14px; height: 14px; stroke: currentColor; fill: none; stroke-width: 2.5; stroke-linecap: round; stroke-linejoin: round; }
.u1-drawer-body { flex: 1; overflow-y: auto; padding: 14px 16px 32px; -webkit-overflow-scrolling: touch; display: flex; flex-direction: column; gap: 16px; }
.u1-drawer-sec { }
.u1-drawer-sec-lbl { font-size: 9px; font-weight: 700; text-transform: uppercase; letter-spacing: .7px; color: var(--u1-t3); margin-bottom: 10px; }
.u1-drawer-stat-row { display: flex; align-items: baseline; gap: 8px; padding: 10px 12px; background: rgba(255,255,255,.03); border: 1px solid var(--u1-brd); border-radius: 8px; }
.u1-drawer-big { font-size: 28px; font-weight: 800; color: var(--u1-ac); letter-spacing: -1px; line-height: 1; }
.u1-drawer-stat-sub { font-size: 11px; color: var(--u1-t3); }
.u1-drawer-empty { font-size: 11px; color: var(--u1-t3); padding: 8px 0; }

/* Shift history */
.u1-shift-list { display: flex; flex-direction: column; gap: 4px; }
.u1-shift-row { display: flex; align-items: center; gap: 10px; padding: 7px 10px; background: rgba(255,255,255,.03); border: 1px solid var(--u1-brd); border-radius: 7px; }
.u1-shift-date { font-size: 10px; font-weight: 600; color: var(--u1-t2); font-family: 'JetBrains Mono', monospace; width: 80px; flex-shrink: 0; }
.u1-shift-time { font-size: 10px; color: var(--u1-t1); flex: 1; }
.u1-shift-off { color: var(--u1-t3); font-style: italic; }
.u1-shift-dur { font-size: 9px; color: var(--c1-ac); font-weight: 700; flex-shrink: 0; }

/* Activity log */
.u1-log-list { display: flex; flex-direction: column; gap: 6px; }
.u1-log-row { display: flex; align-items: flex-start; gap: 8px; }
.u1-log-badge { flex-shrink: 0; width: 28px; height: 20px; display: grid; place-items: center; border-radius: 4px; font-size: 8px; font-weight: 700; text-transform: uppercase; letter-spacing: .3px; background: rgba(255,255,255,.06); color: var(--u1-t2); }
.u1-log-dp { background: rgba(124,92,252,.15); color: var(--c1-dp); }
.u1-log-ld, .u1-log-lead { background: rgba(212,160,23,.15); color: var(--c1-ld); }
.u1-log-na { background: rgba(224,90,58,.15); color: var(--c1-na); }
.u1-log-sc { background: rgba(232,137,28,.15); color: var(--c1-sc); }
.u1-log-body { flex: 1; min-width: 0; }
.u1-log-desc { display: block; font-size: 11px; color: var(--u1-t1); margin-bottom: 2px; }
.u1-log-time { font-size: 9px; color: var(--u1-t3); }

/* ---- Profile panel dark override ---- */
.c1-main .c1-prof-panel { background: var(--u1-bg); }
.c1-main .c1-prof-head { background: var(--u1-surface); border-bottom: 1px solid var(--u1-brd); }
.c1-main .c1-prof-name { color: var(--u1-t1); }
.c1-main .c1-prof-role { color: var(--u1-t3); }
.c1-main .c1-nc-lbl { color: var(--u1-t3); }
.c1-main .c1-nb { border: 1px solid var(--u1-brd); }
.c1-main .c1-nb-dp { background: rgba(99,102,241,.1); color: var(--u1-ac); }
.c1-main .c1-nb-ac { background: rgba(45,157,94,.1); color: var(--c1-ac); }
.c1-main .c1-nb-sc { background: rgba(232,137,28,.1); color: var(--c1-sc); }
.c1-main .c1-nb-rf { background: rgba(199,84,80,.1); color: var(--c1-rf); }
.c1-main .c1-nb-na { background: rgba(255,255,255,.04); color: var(--u1-t2); }
.c1-main .c1-nb-logout { background: rgba(192,57,43,.1); color: #c0392b; }
.c1-main .c1-collapse-bar-lg { background: rgba(255,255,255,.04); border-color: var(--u1-brd); }
.c1-main .c1-prof-toggle { border-color: var(--u1-brd); color: var(--u1-t3); background: transparent; }
.c1-main .c1-prof-toggle.online { border-color: var(--c1-ac); color: var(--c1-ac); background: rgba(45,157,94,.1); }
.c1-main .c1-tz-lbl { color: var(--u1-t3); }
.c1-main .c1-tz-t { color: var(--u1-t1); }
.c1-main .c1-prof-av { background: var(--u1-ac); }
.c1-main .c1-tib-ini { color: #fff; }
.c1-main .c1-prof-brand-name { color: var(--u1-t1); }
.c1-main .c1-prof-brand-name span { color: var(--u1-ac); }
.c1-main .c1-prof-scroll { background: var(--u1-bg); }

/* ---- Drawer slide transition ---- */
.u1-drawer-enter-active, .u1-drawer-leave-active { transition: opacity .22s ease; }
.u1-drawer-enter-active .u1-drawer-inner, .u1-drawer-leave-active .u1-drawer-inner { transition: transform .22s cubic-bezier(.4,0,.2,1); }
.u1-drawer-enter .u1-drawer-inner, .u1-drawer-leave-to .u1-drawer-inner { transform: translateX(100%); }
.u1-drawer-enter, .u1-drawer-leave-to { opacity: 0; }

/* ---- Spinner (uses c1-design global if available, else fallback) ---- */
.c1-spinner { width: 20px; height: 20px; border: 2px solid rgba(99,102,241,.2); border-top-color: var(--u1-ac); border-radius: 50%; animation: u1spin .7s linear infinite; }
@keyframes u1spin { to { transform: rotate(360deg); } }

/* ---- Mobile first: single column expanded grid ---- */
@media (max-width: 400px) {
  .u1-exp-grid { grid-template-columns: 1fr; }
  .u1-qs-row { flex-wrap: wrap; }
  .u1-drawer-inner { max-width: 100%; }
}

/* ---- Credit score mini-bar ---- */
.u1-credit-mini { display: flex; align-items: center; gap: 6px; margin-top: 4px; }
.u1-credit-label { font-size: .7rem; color: var(--c1-muted, #64748b); }
.u1-credit-bar { flex: 1; height: 4px; background: rgba(255,255,255,.1); border-radius: 2px; max-width: 80px; }
.u1-credit-fill { height: 100%; border-radius: 2px; transition: width .3s; }
.u1-credit-val { font-size: .7rem; color: var(--c1-text, #1a1a1a); }

/* ---- Viki button unread indicator ---- */
.u1-viki-dot { width: 6px; height: 6px; border-radius: 50%; background: var(--c1-na, #ef4444); position: absolute; top: 6px; right: 6px; }
.u1-viki-unread { position: relative; }

/* ---- Toast ---- */
.u1-toast {
  position: fixed; bottom: 28px; left: 50%; transform: translateX(-50%);
  z-index: 99999; padding: 10px 22px; border-radius: 24px; color: #fff;
  font-size: .85rem; font-weight: 600; box-shadow: 0 4px 20px rgba(0,0,0,.25);
  pointer-events: none; white-space: nowrap; height: auto;
  display: inline-flex; align-items: center;
}
.u1-toast-fade-enter-active, .u1-toast-fade-leave-active { transition: opacity .25s, transform .25s; }
.u1-toast-fade-enter, .u1-toast-fade-leave-to { opacity: 0; transform: translateX(-50%) translateY(10px); }

/* ---- Add panel — left side ---- */
.u1-add-panel {
  right: auto;
  left: 0;
  border-left: none;
  transform: translateX(-100%);
}
.u1-add-panel.c1-panel--open {
  transform: translateX(0);
  box-shadow: 4px 0 24px rgba(0,0,0,.12);
}

/* ---- Role filter bar (top of user list) ---- */
.u1-list-wrap { flex: 1; display: flex; flex-direction: column; overflow: hidden; }
.u1-role-filter-bar {
  display: flex; gap: 6px; padding: 10px 14px 6px;
  overflow-x: auto; flex-shrink: 0;
  background: var(--u1-surface, #fff);
  border-bottom: 1px solid var(--u1-brd, #e4e3df);
}
.u1-rfb-chip {
  display: inline-flex; align-items: center; gap: 5px;
  padding: 5px 12px; border-radius: 20px;
  font-size: 11px; font-weight: 600;
  background: var(--c1-surface2, #f4f3f0);
  color: var(--u1-t2, #6b6963);
  border: 1px solid var(--u1-brd, #e4e3df);
  cursor: pointer; transition: all .15s; white-space: nowrap;
}
.u1-rfb-chip:hover { border-color: var(--u1-ac); color: var(--u1-ac); }
.u1-rfb-chip.on { background: var(--u1-ac); color: #fff; border-color: var(--u1-ac); }
.u1-rfb-admin.on { background: #ef4444; border-color: #ef4444; }
.u1-rfb-manager.on { background: #e8891c; border-color: #e8891c; }
.u1-rfb-agent.on { background: #6366f1; border-color: #6366f1; }
.u1-rfb-chat.on { background: #2d9d5e; border-color: #2d9d5e; }
.u1-rfb-count {
  font-size: 9px; font-weight: 700; opacity: .75;
  background: rgba(255,255,255,.2); border-radius: 8px; padding: 1px 5px;
}

/* ---- Credit score in collapsed row ---- */
.u1-row-credit {
  font-size: 14px; font-weight: 800; letter-spacing: -.3px;
  min-width: 28px; text-align: center; flex-shrink: 0;
}

/* ---- Online/Offline dot in row ---- */
.u1-row-online-dot {
  width: 8px; height: 8px; border-radius: 50%;
  background: #a09e98; flex-shrink: 0; margin: 0 4px;
  transition: background .2s;
}
.u1-row-online-dot.online {
  background: #22c55e;
  box-shadow: 0 0 0 2px rgba(34,197,94,.2);
}

/* ---- User stats quick view ---- */
/* ---- Accordion sub-tabs ---- */
.u1-subtab-bar {
  display: flex; gap: 2px; margin: 0 0 10px;
  border-bottom: 1px solid var(--u1-brd, #e4e3df);
  padding-bottom: 0;
}
.u1-subtab {
  padding: 6px 14px; font-size: 11px; font-weight: 600; cursor: pointer;
  color: var(--u1-t3, #a09e98); border-bottom: 2px solid transparent;
  margin-bottom: -1px; transition: color .12s, border-color .12s;
}
.u1-subtab:hover { color: var(--u1-t1, #1a1a1a); }
.u1-subtab.on { color: var(--u1-ac, #6366f1); border-bottom-color: var(--u1-ac, #6366f1); }
.u1-subtab-edit.on { color: #f59e0b; border-bottom-color: #f59e0b; }
.u1-exp-sec-lbl { font-size: 9px; font-weight: 700; text-transform: uppercase; letter-spacing: .6px; color: var(--u1-t3, #a09e98); margin-bottom: 8px; }
.u1-edit-form { padding: 4px 0; }

.u1-stats-quick {
  display: flex; gap: 8px; padding: 8px 12px;
  background: var(--c1-surface2, #f4f3f0);
  border-radius: 8px; margin: 8px 12px 0;
}
.u1-sq-item {
  flex: 1; text-align: center;
}
.u1-sq-lbl {
  font-size: 9px; font-weight: 700; text-transform: uppercase;
  letter-spacing: .5px; color: var(--u1-t3, #a09e98); margin-bottom: 2px;
}
.u1-sq-val {
  font-size: 16px; font-weight: 800; color: var(--u1-t1, #1a1a1a);
  letter-spacing: -.3px; line-height: 1.2;
}
.u1-sq-val.u1-sq-small { font-size: 12px; font-weight: 600; }
.u1-sq-sep { font-size: 12px; opacity: .4; margin: 0 1px; }
.u1-sq-sub { font-size: 9px; color: var(--u1-t3, #a09e98); }

/* ---- Credit score badge (collapsed row) ---- */
.u1-score-badge { display: inline-flex; align-items: center; gap: 4px; padding: 3px 8px; border-radius: 20px; font-size: 12px; font-weight: 700; flex-shrink: 0; }
.u1-score-label { font-size: 10px; font-weight: 400; opacity: .8; }

/* ---- Credit score detail panel (expanded row + drawer) ---- */
.u1-score-detail { background: rgba(255,255,255,.03); border-radius: 10px; padding: 12px; margin: 8px 0; }
.u1-score-hdr { font-size: 11px; font-weight: 600; opacity: .5; margin-bottom: 10px; }
.u1-score-main { display: flex; align-items: baseline; gap: 8px; margin-bottom: 12px; }
.u1-score-big { font-size: 36px; font-weight: 800; }
.u1-score-rank { font-size: 13px; font-weight: 600; }
.u1-score-breakdown { display: flex; flex-direction: column; gap: 6px; }
.u1-score-row { display: grid; grid-template-columns: 140px 1fr 30px; gap: 8px; align-items: center; font-size: 12px; }
.u1-score-key { text-transform: capitalize; opacity: .7; }
.u1-score-mini-bar-wrap { height: 4px; background: rgba(255,255,255,.08); border-radius: 2px; overflow: hidden; }
.u1-score-mini-bar { height: 100%; background: var(--c1-dp, #7c5cfc); border-radius: 2px; }
.u1-score-val { font-weight: 600; text-align: right; }

/* ---- Teams tab ---- */
.u1-teams-tab { color: var(--c1-sc) !important; }
.u1-teams-tab.on { background: var(--c1-sc) !important; color: #fff !important; }

/* ---- Teams dropdown ---- */
.u1-teams-dropdown { min-width: 580px; padding: 14px 16px; }
.u1-team-cards { display: flex; gap: 12px; flex-wrap: wrap; margin: 12px 0; }
.u1-team-card { background: rgba(255,255,255,.06); border: 1px solid rgba(255,255,255,.1); border-left: 4px solid var(--tc); border-radius: 10px; padding: 12px 14px; min-width: 180px; flex: 1; }
.u1-team-card-head { display: flex; align-items: center; gap: 8px; margin-bottom: 6px; }
.u1-team-emoji { font-size: 20px; }
.u1-team-name { font-size: 14px; font-weight: 700; color: var(--u1-t1); }
.u1-team-mgr { font-size: 11px; color: var(--u1-t2); margin-bottom: 8px; }
.u1-team-count { display: inline-block; background: rgba(255,255,255,.1); border-radius: 20px; padding: 2px 10px; font-size: 11px; font-weight: 600; margin-bottom: 10px; }
.u1-team-actions { display: flex; gap: 6px; }
.u1-team-btn { padding: 4px 10px; border-radius: 6px; border: 1px solid rgba(0,0,0,.15); background: transparent; color: var(--u1-t2); font-size: 11px; cursor: pointer; transition: all .15s; }
.u1-team-btn:hover { background: rgba(255,255,255,.1); color: var(--u1-t1); }
.u1-team-btn-primary { background: var(--tc, var(--c1-dp)) !important; border-color: var(--tc, var(--c1-dp)) !important; color: #fff !important; }
/* Team form */
.u1-team-form { background: rgba(0,0,0,.06); border-radius: 10px; padding: 14px; margin-top: 8px; border: 1px solid rgba(0,0,0,.08); }
.u1-tf-row { display: flex; gap: 10px; margin-bottom: 10px; }
.u1-tf-field { flex: 1; display: flex; flex-direction: column; gap: 4px; }
.u1-tf-lbl { font-size: 10px; font-weight: 600; text-transform: uppercase; letter-spacing: .04em; color: var(--u1-t2); }
.u1-tf-input, .u1-tf-select { background: rgba(255,255,255,.07); border: 1px solid rgba(0,0,0,.12); border-radius: 7px; color: var(--u1-t1); font-size: 12px; padding: 7px 10px; outline: none; width: 100%; box-sizing: border-box; }
.u1-tf-input:focus, .u1-tf-select:focus { border-color: var(--c1-dp); }
.u1-tf-colors { display: flex; gap: 6px; padding: 4px 0; }
.u1-tf-color-swatch { width: 20px; height: 20px; border-radius: 50%; cursor: pointer; border: 2px solid transparent; transition: transform .15s; flex-shrink: 0; }
.u1-tf-color-swatch.active { transform: scale(1.3); border-color: #fff; box-shadow: 0 0 0 2px rgba(0,0,0,.25); }
.u1-tf-actions { display: flex; gap: 8px; margin-top: 8px; }
.u1-tf-btn { padding: 6px 16px; border-radius: 7px; border: none; font-size: 12px; font-weight: 600; cursor: pointer; transition: opacity .15s; }
.u1-tf-btn:disabled { opacity: .45; cursor: not-allowed; }
.u1-tf-btn-save { background: var(--c1-dp); color: #fff; }
.u1-tf-btn-cancel { background: rgba(0,0,0,.07); color: var(--u1-t2); }
</style>
